import {Coinbase2, MetaMask, WalletConnect} from "react-web3-icons";

export const generalIcons = {
    info: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.2812 9C17.2812 13.1421 13.9234 16.5 9.78125 16.5C5.63911 16.5 2.28125 13.1421 2.28125 9C2.28125 4.85786 5.63911 1.5 9.78125 1.5C13.9234 1.5 17.2812 4.85786 17.2812 9ZM10.5312 5.25C10.5312 5.66421 10.1955 6 9.78125 6C9.36704 6 9.03125 5.66421 9.03125 5.25C9.03125 4.83579 9.36704 4.5 9.78125 4.5C10.1955 4.5 10.5312 4.83579 10.5312 5.25ZM9.03125 6.9375C8.72059 6.9375 8.46875 7.18934 8.46875 7.5C8.46875 7.81066 8.72059 8.0625 9.03125 8.0625H9.21875V12.75C9.21875 13.0607 9.47059 13.3125 9.78125 13.3125C10.0919 13.3125 10.3437 13.0607 10.3437 12.75V7.5C10.3437 7.18934 10.0919 6.9375 9.78125 6.9375H9.03125Z"
                fill="#FFF5F5"
            />
        </svg>
    ),
    await: (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="Exclude"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11 4.8C11 4.24772 10.5523 3.8 10 3.8C9.44771 3.8 9 4.24772 9 4.8V10.92C9 11.1923 9.11104 11.4528 9.30747 11.6414L12.3075 14.5214C12.7059 14.9039 13.3389 14.8909 13.7214 14.4925C14.1039 14.0941 14.0909 13.4611 13.6925 13.0786L11 10.4938V4.8Z"
                fill="#FFE665"
            />
        </svg>
    ),
    error: (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="Subtract"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.25 4C11.25 3.30964 10.6904 2.75 10 2.75C9.30964 2.75 8.75 3.30964 8.75 4V11C8.75 11.6904 9.30964 12.25 10 12.25C10.6904 12.25 11.25 11.6904 11.25 11V4ZM11.25 15.4655C11.25 14.7752 10.6904 14.2155 10 14.2155C9.30964 14.2155 8.75 14.7752 8.75 15.4655V15.4811C8.75 16.1715 9.30964 16.7311 10 16.7311C10.6904 16.7311 11.25 16.1715 11.25 15.4811V15.4655Z"
                fill="#F24949"
            />
        </svg>
    ),
    success: (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="Subtract"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.1224 7.47229C15.5674 6.94444 15.5001 6.15584 14.9723 5.71091C14.4444 5.26598 13.6558 5.33319 13.2109 5.86105L7.84483 12.2272L5.95576 9.98605C5.51083 9.45819 4.72223 9.39098 4.19438 9.83591C3.66653 10.2808 3.59931 11.0694 4.04424 11.5973L6.88907 14.9723C7.12658 15.2541 7.47631 15.4167 7.84483 15.4167C8.21334 15.4167 8.56308 15.2541 8.80059 14.9723L15.1224 7.47229Z"
                fill="#00DF80"
            />
        </svg>
    ),
    wallet: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                d="M24.4657 18.76C24.1857 21.875 21.934 23.9167 18.6673 23.9167H8.16732C4.94732 23.9167 2.33398 21.3034 2.33398 18.0834V9.91671C2.33398 6.74337 4.24732 4.52671 7.22232 4.15337C7.52565 4.10671 7.84065 4.08337 8.16732 4.08337H18.6673C18.9707 4.08337 19.2623 4.09504 19.5423 4.14171C22.3307 4.46837 24.2207 6.41671 24.4657 9.24004C24.5007 9.57837 24.2207 9.85837 23.8823 9.85837H22.074C20.954 9.85837 19.9157 10.29 19.169 11.06C18.2823 11.9234 17.839 13.1367 17.944 14.35C18.1307 16.4734 19.9973 18.1417 22.214 18.1417H23.8823C24.2207 18.1417 24.5007 18.4217 24.4657 18.76Z"
                fill="#FFF5F5"
                // fill="#000000"
            />
            <path
                d="M25.6676 12.7983V15.2016C25.6676 15.8433 25.1542 16.3683 24.5009 16.3916H22.2142C20.9542 16.3916 19.7992 15.4699 19.6942 14.2099C19.6242 13.4749 19.9042 12.7866 20.3942 12.3083C20.8259 11.8649 21.4209 11.6083 22.0742 11.6083H24.5009C25.1542 11.6316 25.6676 12.1566 25.6676 12.7983Z"
                fill="#FFF5F5"
                // fill="#000000"
            />
        </svg>
    ),
    walletHover: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
        >
            <path
                d="M24.4657 18.76C24.1857 21.875 21.934 23.9167 18.6673 23.9167H8.16732C4.94732 23.9167 2.33398 21.3034 2.33398 18.0834V9.91671C2.33398 6.74337 4.24732 4.52671 7.22232 4.15337C7.52565 4.10671 7.84065 4.08337 8.16732 4.08337H18.6673C18.9707 4.08337 19.2623 4.09504 19.5423 4.14171C22.3307 4.46837 24.2207 6.41671 24.4657 9.24004C24.5007 9.57837 24.2207 9.85837 23.8823 9.85837H22.074C20.954 9.85837 19.9157 10.29 19.169 11.06C18.2823 11.9234 17.839 13.1367 17.944 14.35C18.1307 16.4734 19.9973 18.1417 22.214 18.1417H23.8823C24.2207 18.1417 24.5007 18.4217 24.4657 18.76Z"
                // fill="#FFF5F5"
                fill="#000000"
            />
            <path
                d="M25.6676 12.7983V15.2016C25.6676 15.8433 25.1542 16.3683 24.5009 16.3916H22.2142C20.9542 16.3916 19.7992 15.4699 19.6942 14.2099C19.6242 13.4749 19.9042 12.7866 20.3942 12.3083C20.8259 11.8649 21.4209 11.6083 22.0742 11.6083H24.5009C25.1542 11.6316 25.6676 12.1566 25.6676 12.7983Z"
                // fill="#FFF5F5"
                fill="#000000"
            />
        </svg>
    ),
    refresh: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M16.6071 8.61806L18.8683 8.89343L21.4862 9.21947C21.7816 9.26058 22.036 9.00529 21.9958 8.70985L21.6698 6.09201L21.3944 3.83072C21.3437 3.45399 20.8848 3.29051 20.6199 3.56588L19.3874 4.79836C17.4627 2.87363 14.9059 1.81433 12.1857 1.81433C9.46655 1.81433 6.90965 2.87373 4.98403 4.79836C3.0593 6.72308 2 9.2799 2 12.0001C2 14.7192 3.0594 17.2761 4.98403 19.2018C6.90875 21.1265 9.46557 22.1858 12.1857 22.1858C14.9049 22.1858 17.4618 21.1264 19.3874 19.2018C20.3044 18.2848 21.0272 17.2159 21.5368 16.0342C21.8122 15.3926 21.5168 14.6382 20.8647 14.3638C20.2231 14.0884 19.4687 14.3839 19.1943 15.036C18.8176 15.9223 18.2678 16.7169 17.5851 17.4091C16.1384 18.8558 14.2234 19.6503 12.1866 19.6503C10.1491 19.6503 8.23478 18.8557 6.78817 17.4091C5.34156 15.9625 4.54698 14.0474 4.54698 12.0106C4.54698 9.9731 5.34154 8.05878 6.78817 6.61217C8.2348 5.16556 10.1499 4.37098 12.1866 4.37098C14.2242 4.37098 16.1385 5.16554 17.5851 6.61217L16.3526 7.84465C16.0878 8.1095 16.2408 8.57801 16.6175 8.61914L16.6071 8.61806Z"
                fill="white"
            />
        </svg>
    ),
    disconnectWallet: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
        >
            <path
                d="M13.7259 0.937763C13.1279 0.340026 12.317 0.00424012 11.4715 0.00424012C10.626 0.00424012 9.81514 0.340026 9.21717 0.937763L6.40922 3.74705C6.35642 3.79933 6.31451 3.86155 6.28591 3.93013C6.25731 3.9987 6.24259 4.07226 6.24259 4.14656C6.24259 4.22086 6.25731 4.29443 6.28591 4.363C6.31451 4.43157 6.35642 4.4938 6.40922 4.54608C6.4615 4.59887 6.52372 4.64078 6.5923 4.66938C6.66087 4.69798 6.73443 4.71271 6.80873 4.71271C6.88303 4.71271 6.95659 4.69798 7.02517 4.66938C7.09374 4.64078 7.15597 4.59887 7.20825 4.54608L10.0169 1.7368C10.3049 1.44993 10.6714 1.25473 11.0702 1.17578C11.469 1.09683 11.8822 1.13766 12.2579 1.29313C12.6335 1.44861 12.9547 1.71176 13.1811 2.04945C13.4074 2.38714 13.5287 2.78426 13.5298 3.19079C13.5298 3.74038 13.3157 4.25661 12.9262 4.64479L10.1182 7.45274C10.0381 7.53131 9.98326 7.63208 9.96086 7.74207C9.93845 7.85206 9.94948 7.96624 9.99253 8.06991C10.0356 8.17358 10.1087 8.26199 10.2024 8.32376C10.2961 8.38553 10.4062 8.41784 10.5184 8.41651C10.6683 8.41685 10.8121 8.35787 10.9186 8.25244L13.7279 5.44316C14.3249 4.8454 14.6602 4.03503 14.6599 3.19018C14.6597 2.34534 14.3239 1.53517 13.7266 0.937763H13.7259ZM5.54215 3.39355C5.61636 3.39382 5.68988 3.37941 5.7585 3.35115C5.82711 3.3229 5.88947 3.28135 5.94197 3.22891C5.99447 3.17647 6.03609 3.11417 6.06442 3.04559C6.09276 2.97701 6.10725 2.9035 6.10708 2.82929L6.10508 0.564259C6.10525 0.490111 6.09078 0.416658 6.06248 0.348119C6.03419 0.279581 5.99263 0.217308 5.9402 0.164877C5.88777 0.112445 5.8255 0.0708892 5.75696 0.0425949C5.68842 0.0143006 5.61497 -0.000174333 5.54082 1.58441e-06C5.46667 -0.000174331 5.39322 0.0143006 5.32468 0.0425949C5.25614 0.0708892 5.19387 0.112445 5.14144 0.164877C5.08901 0.217308 5.04745 0.279581 5.01916 0.348119C4.99086 0.416658 4.97639 0.490111 4.97656 0.564259V2.83063C4.97636 2.90467 4.99101 2.978 5.01965 3.04628C5.04829 3.11456 5.09034 3.1764 5.1433 3.22814C5.19577 3.2806 5.25806 3.3222 5.32661 3.35059C5.39516 3.37897 5.46863 3.39357 5.54282 3.39355H5.54215ZM12.3039 10.8323C12.2516 10.7801 12.1895 10.7389 12.1211 10.711C12.0528 10.683 11.9796 10.669 11.9057 10.6695C11.7941 10.6693 11.6848 10.7023 11.5919 10.7642C11.4989 10.8261 11.4265 10.9142 11.3836 11.0173C11.3408 11.1204 11.3295 11.2339 11.3512 11.3435C11.3729 11.453 11.4266 11.5537 11.5055 11.6327L13.1076 13.2334C13.1599 13.2862 13.2221 13.3281 13.2907 13.3567C13.3593 13.3853 13.4328 13.4 13.5071 13.4C13.5814 13.4 13.655 13.3853 13.7236 13.3567C13.7921 13.3281 13.8544 13.2862 13.9066 13.2334C13.9594 13.1811 14.0013 13.1189 14.0299 13.0503C14.0585 12.9817 14.0733 12.9082 14.0733 12.8339C14.0733 12.7596 14.0585 12.686 14.0299 12.6174C14.0013 12.5489 13.9594 12.4866 13.9066 12.4344L12.3039 10.8323ZM14.0941 8.55124H11.827C11.753 8.55122 11.6798 8.56602 11.6117 8.59477C11.5435 8.62352 11.4818 8.66565 11.4302 8.71865C11.3508 8.79719 11.2966 8.89757 11.2744 9.00702C11.2522 9.11647 11.2631 9.23004 11.3056 9.3333C11.3482 9.43655 11.4204 9.52481 11.5133 9.58687C11.6061 9.64892 11.7154 9.68195 11.827 9.68176L14.0927 9.67976C14.1669 9.67993 14.2403 9.66546 14.3089 9.63717C14.3774 9.60887 14.4397 9.56732 14.4921 9.51488C14.5445 9.46245 14.5861 9.40018 14.6144 9.33164C14.6427 9.2631 14.6572 9.18965 14.657 9.1155C14.6575 9.04137 14.6433 8.96786 14.6152 8.89925C14.5872 8.83064 14.5457 8.76829 14.4934 8.7158C14.441 8.66332 14.3788 8.62175 14.3102 8.5935C14.2417 8.56525 14.1682 8.55089 14.0941 8.55124ZM9.78076 10.6135C9.70661 10.6133 9.63316 10.6278 9.56462 10.6561C9.49608 10.6844 9.43381 10.726 9.38137 10.7784C9.32894 10.8308 9.28739 10.8931 9.25909 10.9616C9.2308 11.0302 9.21632 11.1036 9.2165 11.1778L9.2185 13.4428C9.21832 13.517 9.2328 13.5904 9.26109 13.659C9.28939 13.7275 9.33094 13.7898 9.38338 13.8422C9.43581 13.8946 9.49808 13.9362 9.56662 13.9645C9.63516 13.9928 9.70861 14.0072 9.78276 14.0071C9.85691 14.0072 9.93036 13.9928 9.9989 13.9645C10.0674 13.9362 10.1297 13.8946 10.1821 13.8422C10.2346 13.7898 10.2761 13.7275 10.3044 13.659C10.3327 13.5904 10.3472 13.517 10.347 13.4428V11.1758C10.3471 11.1018 10.3324 11.0286 10.3038 10.9605C10.2752 10.8923 10.2332 10.8306 10.1803 10.7789C10.1278 10.7265 10.0655 10.6849 9.99697 10.6565C9.92842 10.6281 9.85495 10.6135 9.78076 10.6135ZM8.10999 9.46299L5.30204 12.2716C5.11154 12.4632 4.88497 12.6152 4.63542 12.7188C4.38586 12.8224 4.11825 12.8756 3.84805 12.8752C3.57787 12.876 3.31024 12.8231 3.06073 12.7194C2.81123 12.6158 2.58483 12.4636 2.39472 12.2716C2.20307 12.0812 2.05095 11.8547 1.94711 11.6053C1.84327 11.3559 1.78975 11.0884 1.78962 10.8182C1.7895 10.548 1.84278 10.2805 1.94639 10.031C2.05 9.78148 2.20191 9.5549 2.39338 9.36428L5.20267 6.555C5.25536 6.50273 5.29718 6.44055 5.32572 6.37203C5.35427 6.30352 5.36896 6.23003 5.36896 6.15581C5.36896 6.08159 5.35427 6.00811 5.32572 5.9396C5.29718 5.87108 5.25536 5.8089 5.20267 5.75663C5.15039 5.70384 5.08816 5.66193 5.01959 5.63333C4.95101 5.60473 4.87745 5.59 4.80315 5.59C4.72885 5.59 4.65529 5.60473 4.58671 5.63333C4.51814 5.66193 4.45591 5.70384 4.40363 5.75663L1.59435 8.56258C1.29724 8.85787 1.06166 9.20917 0.901262 9.59614C0.740865 9.98311 0.658835 10.3981 0.659923 10.8169C0.659923 11.6667 0.991408 12.469 1.59435 13.0693C1.88992 13.3656 2.24112 13.6005 2.62777 13.7606C3.01441 13.9208 3.42889 14.0029 3.84738 14.0024C4.66309 14.0024 5.48079 13.6909 6.09974 13.0686L8.91036 10.2614C8.96305 10.2091 9.00488 10.1469 9.03342 10.0784C9.06196 10.0099 9.07665 9.93639 9.07665 9.86217C9.07665 9.78796 9.06196 9.71447 9.03342 9.64596C9.00488 9.57745 8.96305 9.51526 8.91036 9.46299C8.8041 9.3571 8.6602 9.29764 8.51018 9.29764C8.36016 9.29764 8.21626 9.3571 8.10999 9.46299ZM3.01967 3.17479C3.13239 3.28417 3.27312 3.33886 3.41785 3.33753C3.52952 3.33773 3.63874 3.3048 3.73169 3.2429C3.82463 3.18099 3.89712 3.0929 3.93997 2.98978C3.98282 2.88666 3.9941 2.77314 3.9724 2.66359C3.95069 2.55405 3.89697 2.45341 3.81803 2.37442L2.21663 0.775022C2.16435 0.722228 2.10213 0.68032 2.03355 0.651719C1.96498 0.623118 1.89142 0.608391 1.81712 0.608391C1.74282 0.608391 1.66926 0.623118 1.60068 0.651719C1.53211 0.68032 1.46988 0.722228 1.4176 0.775022C1.36481 0.827302 1.3229 0.889528 1.2943 0.958102C1.2657 1.02668 1.25097 1.10024 1.25097 1.17454C1.25097 1.24884 1.2657 1.3224 1.2943 1.39097C1.3229 1.45955 1.36481 1.52177 1.4176 1.57405L3.02033 3.17479H3.01967ZM1.22952 5.45716H3.49722C3.57115 5.45728 3.64436 5.44258 3.71251 5.41394C3.78067 5.3853 3.84241 5.3433 3.89407 5.29042C3.97369 5.21192 4.02813 5.11148 4.05044 5.00192C4.07276 4.89235 4.06194 4.77863 4.01937 4.67523C3.9768 4.57184 3.9044 4.48347 3.8114 4.42139C3.71841 4.35931 3.60903 4.32632 3.49722 4.32665L1.23152 4.32865C1.15737 4.32847 1.08392 4.34295 1.01538 4.37124C0.946839 4.39953 0.884566 4.44109 0.832135 4.49352C0.779703 4.54595 0.738147 4.60823 0.709853 4.67676C0.681558 4.7453 0.667084 4.81876 0.667259 4.8929C0.666549 4.96709 0.680615 5.04067 0.708636 5.10936C0.736658 5.17806 0.778074 5.24048 0.830471 5.293C0.882868 5.34552 0.945196 5.38709 1.01382 5.41527C1.08245 5.44346 1.156 5.4577 1.23018 5.45716H1.22952Z"
                fill="currentColor"
            />
        </svg>
    ),
    arrow_Wallet_Modal: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
        >
            <circle
                cx="16"
                cy="16"
                r="11"
                stroke="#242424"
                strokeWidth="2"
            />
            <path
                d="M20 20L12 12M12 20L20 12"
                stroke="#242424"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    tooltip: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            className="w-5 h-5 md:w-[18px] md:h-[18px]"
        >
            <path
                d="M10.9997 20.1667C16.0413 20.1667 20.1663 16.0417 20.1663 11C20.1663 5.95837 16.0413 1.83337 10.9997 1.83337C5.95801 1.83337 1.83301 5.95837 1.83301 11C1.83301 16.0417 5.95801 20.1667 10.9997 20.1667Z"
                stroke="#292D32"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11 7.33334V11.9167"
                stroke="#292D32"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.9951 14.6667H11.0034"
                stroke="#292D32"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    externalLink: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M9.16675 7.33337L14.6334 1.8667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.1668 4.53337V1.33337H11.9668"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.83325 1.33337H6.49992C3.16659 1.33337 1.83325 2.66671 1.83325 6.00004V10C1.83325 13.3334 3.16659 14.6667 6.49992 14.6667H10.4999C13.8333 14.6667 15.1666 13.3334 15.1666 10V8.66671"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    search: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
        >
            <g opacity="0.5">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.4109 10.5417C16.4109 13.7831 13.7833 16.4107 10.542 16.4107C7.30069 16.4107 4.67309 13.7831 4.67309 10.5417C4.67309 7.30044 7.30069 4.67285 10.542 4.67285C13.7833 4.67285 16.4109 7.30044 16.4109 10.5417ZM10.542 17.4167C14.339 17.4167 17.417 14.3387 17.417 10.5417C17.417 6.74479 14.339 3.66675 10.542 3.66675C6.74503 3.66675 3.66699 6.74479 3.66699 10.5417C3.66699 14.3387 6.74503 17.4167 10.542 17.4167ZM16.59 15.756C16.3598 15.5259 15.9867 15.5259 15.7566 15.756C15.5265 15.9862 15.5265 16.3593 15.7566 16.5894L17.328 18.1608C17.5581 18.391 17.9313 18.391 18.1614 18.1608C18.3915 17.9307 18.3915 17.5576 18.1614 17.3275L16.59 15.756Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    ),
    cardIcon: (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.57171 -0.0065918C5.8445 0.0862741 6.109 0.201925 6.3624 0.339139C6.89381 0.683269 7.10829 1.21787 7.11309 1.8325C7.12269 2.97854 7.12269 4.12404 7.11309 5.269C7.11309 6.02129 6.77536 6.60231 6.0871 6.92403C5.82638 7.0369 5.5453 7.09519 5.26119 7.09529C4.12956 7.1145 2.99633 7.1081 1.8647 7.09529C0.918747 7.09529 0.2641 6.56549 0.0384145 5.64514C0.0271044 5.61621 0.0142819 5.5879 0 5.56031C0 4.22221 0 2.88357 0 1.54439C0.0176067 1.50758 0.0320121 1.47077 0.0416157 1.43395C0.148856 0.996987 0.340929 0.603239 0.733077 0.361547C0.998429 0.219872 1.27333 0.0968605 1.55579 -0.0065918L5.57171 -0.0065918Z"
                fill="currentColor"
            />
            <path
                d="M0 10.4117C0.105667 10.1298 0.234698 9.85731 0.385746 9.59696C0.529268 9.37993 0.725239 9.20263 0.955507 9.08148C1.18577 8.96033 1.44289 8.89925 1.70304 8.9039C2.9227 8.8911 4.14077 8.8959 5.36043 8.9039C5.59546 8.90382 5.82813 8.95081 6.04472 9.04208C6.26131 9.13335 6.45743 9.26706 6.62152 9.43533C6.78561 9.6036 6.91435 9.80302 7.00015 10.0218C7.08595 10.2406 7.12707 10.4744 7.12109 10.7094C7.12909 11.8682 7.1355 13.0287 7.12109 14.1875C7.10669 15.2263 6.40242 15.9626 5.37003 15.9866C4.17118 16.0138 2.96912 16.0122 1.77187 15.9866C0.875531 15.9642 0.272103 15.444 0.0432163 14.578C0.0336127 14.5396 0.0176067 14.5044 0 14.4692C0 13.1162 0 11.7636 0 10.4117Z"
                fill="currentColor"
            />
            <path
                d="M14.4407 -0.0065918C14.7653 0.059798 15.0717 0.195771 15.3387 0.391959C15.5293 0.535986 15.6856 0.720522 15.7963 0.932262C15.907 1.144 15.9694 1.37767 15.9789 1.61642C16.0013 2.60239 15.9933 3.58997 15.9965 4.57754C15.9965 4.82884 15.9965 5.08173 15.9965 5.33303C15.9962 5.5703 15.9483 5.8051 15.8556 6.02352C15.7629 6.24194 15.6273 6.43954 15.4568 6.60461C15.2864 6.76968 15.0845 6.89888 14.8633 6.98453C14.642 7.07019 14.4058 7.11058 14.1686 7.1033C13.0226 7.1033 11.8765 7.1129 10.7305 7.1033C9.68692 7.09049 8.94103 6.39583 8.91542 5.36664C8.88501 4.15498 8.88821 2.94172 8.91542 1.73006C8.93303 0.846531 9.47083 0.239901 10.3352 0.0286215C10.3653 0.0189703 10.3947 0.00720329 10.4232 -0.0065918L14.4407 -0.0065918Z"
                fill="currentColor"
            />
            <path
                d="M15.99 12.4397C15.99 13.0799 16.0124 13.7202 15.99 14.3476C15.9753 14.7736 15.7993 15.1781 15.4977 15.4794C15.1962 15.7807 14.7915 15.9563 14.3654 15.9706C13.0849 16.0005 11.8044 16.0005 10.524 15.9706C10.1026 15.9542 9.7031 15.7789 9.40583 15.4798C9.10856 15.1808 8.9356 14.7802 8.92175 14.3588C8.89294 13.0783 8.89294 11.7978 8.92175 10.5173C8.93443 10.0956 9.10675 9.69449 9.40388 9.39499C9.70101 9.09548 10.1008 8.91997 10.5224 8.90393C11.8028 8.87512 13.0876 8.87512 14.3766 8.90393C14.7948 8.92342 15.1907 9.09831 15.4868 9.39436C15.7828 9.69041 15.9577 10.0863 15.9772 10.5045C16.006 11.1448 15.9772 11.785 15.9772 12.4253L15.99 12.4397Z"
                fill="currentColor"
            />
        </svg>
    ),
    tabularIcon: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M3.66667 8.11117C4.58714 8.11117 5.33333 7.36497 5.33333 6.4445C5.33333 5.52402 4.58714 4.77783 3.66667 4.77783C2.74619 4.77783 2 5.52402 2 6.4445C2 7.36497 2.74619 8.11117 3.66667 8.11117Z"
                fill="currentColor"
            />
            <path
                d="M10.3334 8.11117H20.3334C20.7754 8.11117 21.1994 7.93557 21.5119 7.62301C21.8245 7.31045 22.0001 6.88653 22.0001 6.4445C22.0001 6.00247 21.8245 5.57855 21.5119 5.26599C21.1994 4.95343 20.7754 4.77783 20.3334 4.77783H10.3334C9.89139 4.77783 9.46746 4.95343 9.1549 5.26599C8.84234 5.57855 8.66675 6.00247 8.66675 6.4445C8.66675 6.88653 8.84234 7.31045 9.1549 7.62301C9.46746 7.93557 9.89139 8.11117 10.3334 8.11117Z"
                fill="currentColor"
            />
            <path
                d="M3.66667 13.6666C4.58714 13.6666 5.33333 12.9204 5.33333 11.9999C5.33333 11.0794 4.58714 10.3333 3.66667 10.3333C2.74619 10.3333 2 11.0794 2 11.9999C2 12.9204 2.74619 13.6666 3.66667 13.6666Z"
                fill="currentColor"
            />
            <path
                d="M20.3334 10.3333H10.3334C9.89139 10.3333 9.46746 10.5088 9.1549 10.8214C8.84234 11.134 8.66675 11.5579 8.66675 11.9999C8.66675 12.4419 8.84234 12.8659 9.1549 13.1784C9.46746 13.491 9.89139 13.6666 10.3334 13.6666H20.3334C20.7754 13.6666 21.1994 13.491 21.5119 13.1784C21.8245 12.8659 22.0001 12.4419 22.0001 11.9999C22.0001 11.5579 21.8245 11.134 21.5119 10.8214C21.1994 10.5088 20.7754 10.3333 20.3334 10.3333Z"
                fill="currentColor"
            />
            <path
                d="M3.66667 19.2222C4.58714 19.2222 5.33333 18.4761 5.33333 17.5556C5.33333 16.6351 4.58714 15.8889 3.66667 15.8889C2.74619 15.8889 2 16.6351 2 17.5556C2 18.4761 2.74619 19.2222 3.66667 19.2222Z"
                fill="currentColor"
            />
            <path
                d="M20.3334 15.8889H10.3334C9.89139 15.8889 9.46746 16.0645 9.1549 16.3771C8.84234 16.6896 8.66675 17.1136 8.66675 17.5556C8.66675 17.9976 8.84234 18.4215 9.1549 18.7341C9.46746 19.0467 9.89139 19.2222 10.3334 19.2222H20.3334C20.7754 19.2222 21.1994 19.0467 21.5119 18.7341C21.8245 18.4215 22.0001 17.9976 22.0001 17.5556C22.0001 17.1136 21.8245 16.6896 21.5119 16.3771C21.1994 16.0645 20.7754 15.8889 20.3334 15.8889Z"
                fill="currentColor"
            />
        </svg>
    ),
    backArrow: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M12.5 15L7.5 10L12.5 5"
                stroke="#F7F7F7"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    rightArrow: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="12"
            viewBox="0 0 6 12"
            fill="none"
        >
            <path
                d="M1 1L5 6L1 11"
                stroke="#03D9AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    externalLinkArrow: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M9.77778 1.77778C9.28684 1.77778 8.88889 1.3798 8.88889 0.888889C8.88889 0.397973 9.28684 0 9.77778 0H15.1111C15.3468 0 15.573 0.0936534 15.7396 0.260347C15.9063 0.427049 16 0.653138 16 0.888889V6.22222C16 6.71316 15.602 7.11111 15.1111 7.11111C14.6202 7.11111 14.2222 6.71316 14.2222 6.22222V3.03486L5.96188 11.2952C5.61474 11.6423 5.05193 11.6423 4.70479 11.2952C4.35766 10.9481 4.35766 10.3852 4.70479 10.0381L12.9652 1.77778H9.77778ZM0 3.55556C0 2.57372 0.795938 1.77778 1.77778 1.77778H6.22222C6.71316 1.77778 7.11111 2.17575 7.11111 2.66667C7.11111 3.15758 6.71316 3.55556 6.22222 3.55556H1.77778V14.2222H12.4444V9.77778C12.4444 9.28684 12.8424 8.88889 13.3333 8.88889C13.8243 8.88889 14.2222 9.28684 14.2222 9.77778V14.2222C14.2222 15.2041 13.4263 16 12.4444 16H1.77778C0.795938 16 0 15.2041 0 14.2222V3.55556Z"
                fill="currentColor"
            />
        </svg>
    ),
    calculator: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
        >
            <path
                d="M18.6667 2.83337H9.33333C6.11333 2.83337 3.5 5.44671 3.5 8.66671V20.3334C3.5 23.5534 6.11333 26.1667 9.33333 26.1667H18.6667C21.8867 26.1667 24.5 23.5534 24.5 20.3334V8.66671C24.5 5.44671 21.8867 2.83337 18.6667 2.83337ZM10.3367 22.235C10.115 22.4567 9.82333 22.5734 9.52 22.5734C9.205 22.5734 8.91333 22.4567 8.69167 22.235C8.47 22.0134 8.34167 21.7217 8.34167 21.4067C8.34167 21.1034 8.47 20.8 8.69167 20.5784C8.79667 20.4734 8.925 20.3917 9.065 20.3334C9.35667 20.2167 9.67167 20.2167 9.96333 20.3334C10.0333 20.3567 10.1033 20.3917 10.1617 20.4384C10.2317 20.4734 10.29 20.5317 10.3367 20.5784C10.5583 20.8 10.6867 21.1034 10.6867 21.4067C10.6867 21.7217 10.5583 22.0134 10.3367 22.235ZM8.34167 16.74C8.34167 16.5884 8.37667 16.4367 8.435 16.2967C8.49333 16.145 8.575 16.0284 8.69167 15.9117C8.96 15.6434 9.36833 15.515 9.74167 15.5967C9.81167 15.6084 9.89333 15.6317 9.96333 15.6667C10.0333 15.69 10.1033 15.725 10.1617 15.7717C10.2317 15.8067 10.29 15.865 10.3367 15.9117C10.4417 16.0284 10.535 16.145 10.5933 16.2967C10.6517 16.4367 10.675 16.5884 10.675 16.74C10.675 17.055 10.5583 17.3467 10.3367 17.5684C10.115 17.79 9.82333 17.9067 9.52 17.9067C9.35667 17.9067 9.205 17.8717 9.065 17.8134C8.925 17.755 8.79667 17.6734 8.69167 17.5684C8.47 17.3467 8.34167 17.055 8.34167 16.74ZM15.0033 22.235C14.8983 22.34 14.77 22.4217 14.63 22.48C14.49 22.5384 14.3383 22.5734 14.175 22.5734C13.8717 22.5734 13.58 22.4567 13.3583 22.235C13.1367 22.0134 13.0083 21.7217 13.0083 21.4067C13.0083 21.325 13.02 21.255 13.0317 21.1734C13.055 21.1034 13.0783 21.0334 13.1017 20.9634C13.1367 20.8934 13.1717 20.8234 13.2067 20.7534C13.2533 20.695 13.3 20.6367 13.3583 20.5784C13.4633 20.4734 13.5917 20.3917 13.7317 20.3334C14.1633 20.1584 14.6767 20.2517 15.0033 20.5784C15.225 20.8 15.3417 21.1034 15.3417 21.4067C15.3417 21.7217 15.225 22.0134 15.0033 22.235ZM15.0033 17.5684C14.7817 17.79 14.49 17.9067 14.175 17.9067C13.8717 17.9067 13.58 17.79 13.3583 17.5684C13.1367 17.3467 13.0083 17.055 13.0083 16.74C13.0083 16.4367 13.1367 16.1334 13.3583 15.9117C13.79 15.48 14.5717 15.48 15.0033 15.9117C15.1083 16.0284 15.2017 16.145 15.26 16.2967C15.3183 16.4367 15.3417 16.5884 15.3417 16.74C15.3417 17.055 15.225 17.3467 15.0033 17.5684ZM10.5 12.7034C9.29833 12.7034 8.30667 11.7234 8.30667 10.51V9.34337C8.30667 8.14171 9.28667 7.15004 10.5 7.15004H17.5C18.7017 7.15004 19.6933 8.13004 19.6933 9.34337V10.51C19.6933 11.7117 18.7133 12.7034 17.5 12.7034H10.5ZM19.67 22.235C19.4483 22.4567 19.1567 22.5734 18.8417 22.5734C18.69 22.5734 18.5383 22.5384 18.3983 22.48C18.2583 22.4217 18.13 22.34 18.025 22.235C17.8033 22.0134 17.6867 21.7217 17.6867 21.4067C17.6867 21.1034 17.8033 20.8 18.025 20.5784C18.34 20.2517 18.865 20.1584 19.2967 20.3334C19.4367 20.3917 19.565 20.4734 19.67 20.5784C19.8917 20.8 20.0083 21.1034 20.0083 21.4067C20.0083 21.7217 19.8917 22.0134 19.67 22.235ZM19.9267 17.1834C19.8683 17.3234 19.7867 17.4517 19.67 17.5684C19.4483 17.79 19.1567 17.9067 18.8417 17.9067C18.5383 17.9067 18.2467 17.79 18.025 17.5684C17.8033 17.3467 17.675 17.055 17.675 16.74C17.675 16.4367 17.8033 16.1334 18.025 15.9117C18.4567 15.48 19.2383 15.48 19.67 15.9117C19.8917 16.1334 20.02 16.4367 20.02 16.74C20.02 16.8917 19.985 17.0434 19.9267 17.1834Z"
                fill="currentColor"
            />
        </svg>
    ),
    reward: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="29"
            viewBox="0 0 28 29"
            fill="none"
        >
            <path
                d="M6.38885 7.54538V11.4529C6.38885 12.2236 6.50289 12.9668 6.71593 13.6686L5.66198 13.6673C4.47521 13.6623 3.51901 12.6999 3.51901 11.5118C3.51901 11.5106 3.51525 7.54554 3.51525 7.54554L6.38885 7.54538ZM24.4849 7.54538V7.54789L24.4811 11.5116C24.4811 12.6996 23.5249 13.6621 22.3394 13.6671L21.2842 13.6684C21.4972 12.9666 21.6113 12.2234 21.6113 11.4527V7.54516L24.4849 7.54538ZM18.423 8.53539V8.53665C18.8379 8.53539 19.175 8.86622 19.1812 9.27979L19.1825 11.4528C19.1825 13.508 17.9945 15.2863 16.2663 16.1374C16.1648 16.1875 16.0508 16.2151 15.9317 16.2151C15.5131 16.2151 15.1735 15.8755 15.1735 15.4569C15.1735 15.1611 15.3439 14.9042 15.5908 14.7802H15.5921C16.8215 14.1774 17.6674 12.9142 17.6674 11.453C17.6661 9.45412 17.6661 9.29121 17.6661 9.29121C17.6661 8.87389 18.0032 8.53552 18.4206 8.53552L18.423 8.53539ZM8.128 2.54766L8.08916 2.54891C7.15176 2.57397 6.40111 3.33716 6.38857 4.27706V6.03026H2.7582L2.75694 6.03151H2.75569L2.75444 6.03277H2.75318V6.03402H2.75193C2.33586 6.03402 2 6.37114 2 6.7872V11.5167C2.00251 13.5394 3.64044 15.1785 5.66309 15.1849L7.36493 15.1862C8.26473 16.7803 9.71842 18.0184 11.4704 18.635V18.6362C11.6496 19.0698 11.7624 19.5962 11.7624 20.209C11.7624 20.5761 11.7223 20.912 11.6521 21.2153H10.4403C9.33626 21.2303 8.44522 22.1301 8.44522 23.2367V24.9385H7.89884C7.48027 24.9385 7.14065 25.2781 7.14065 25.6954C7.14065 26.114 7.48027 26.4536 7.89884 26.4536H20.1024C20.5197 26.4536 20.8593 26.114 20.8593 25.6954C20.8593 25.2781 20.5197 24.9385 20.1024 24.9385H19.5548V23.2367C19.5548 22.1289 18.6638 21.2291 17.5597 21.2153H16.3479C16.2777 20.9107 16.2376 20.5749 16.2376 20.209C16.2376 19.5961 16.3491 19.0685 16.5283 18.635H16.5296C18.2803 18.0184 19.7352 16.7803 20.6351 15.1849H22.3369C24.3596 15.1786 25.9974 13.5395 26 11.5167V6.78718C26 6.36861 25.6604 6.03024 25.2418 6.03024H21.6114V4.29959C21.6114 3.33088 20.8282 2.54639 19.8607 2.54639L8.128 2.54766Z"
                fill="currentColor"
            />
        </svg>
    ),
    copyAddress: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.5331 6.3448H6.68555V5.93045C6.68555 4.09971 8.16965 2.6156 10.0004 2.6156H14.9727C16.8034 2.6156 18.2875 4.09971 18.2875 5.93045V10.9027C18.2875 12.7335 16.8034 14.2176 14.9727 14.2176H14.5583V10.37C14.5583 8.14693 12.7562 6.3448 10.5331 6.3448ZM10 19.1898H5.02774C3.197 19.1898 1.71289 17.7057 1.71289 15.875V10.9027C1.71289 9.07198 3.197 7.58787 5.02774 7.58787H10C11.8307 7.58787 13.3149 9.07198 13.3149 10.9027V15.875C13.3149 17.7057 11.8307 19.1898 10 19.1898Z"
                fill="currentColor"
            />
        </svg>
    ),
    copied: (
        <svg
            width="16"
            height="11"
            viewBox="0 0 16 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 7L4.52642 9.82114C5.35374 10.483 6.55365 10.3848 7.2624 9.59733L15 1"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    edit: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM8.2125 13.1325C7.995 13.35 7.5825 13.56 7.2825 13.605L5.4375 13.8675C5.37 13.875 5.3025 13.8825 5.235 13.8825C4.9275 13.8825 4.6425 13.7775 4.44 13.575C4.1925 13.3275 4.0875 12.9675 4.1475 12.57L4.41 10.725C4.455 10.4175 4.6575 10.0125 4.8825 9.795L8.2275 6.45C8.2875 6.6075 8.3475 6.765 8.43 6.945C8.505 7.1025 8.5875 7.2675 8.6775 7.4175C8.7525 7.545 8.835 7.665 8.9025 7.755C8.985 7.8825 9.0825 8.0025 9.1425 8.07C9.18 8.1225 9.21 8.16 9.225 8.175C9.4125 8.4 9.63 8.61 9.8175 8.7675C9.87 8.82 9.9 8.85 9.915 8.8575C10.0275 8.9475 10.14 9.0375 10.2375 9.105C10.3575 9.195 10.4775 9.2775 10.605 9.345C10.755 9.435 10.92 9.5175 11.085 9.6C11.2575 9.675 11.415 9.7425 11.5725 9.795L8.2125 13.1325ZM13.0275 8.3175L12.3375 9.015C12.2925 9.06 12.2325 9.0825 12.1725 9.0825C12.15 9.0825 12.12 9.0825 12.105 9.075C10.5825 8.64 9.3675 7.425 8.9325 5.9025C8.91 5.82 8.9325 5.73 8.9925 5.6775L9.69 4.98C10.83 3.84 11.9175 3.8625 13.035 4.98C13.605 5.55 13.8825 6.0975 13.8825 6.6675C13.875 7.2075 13.5975 7.7475 13.0275 8.3175Z"
                fill="#A08CFF"
            />
        </svg>
    ),
    vanry: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="16"
            viewBox="0 0 19 16"
            fill="none"
        >
            <path
                d="M11.748 16L13.9971 11.9982L7.24971 0H2.74912L0.5 3.9994H5.00293L11.748 16ZM16.2485 7.9988L18.5 3.9994L16.2485 0H11.7503L9.50118 3.9994H13.9994L16.2485 7.9988Z"
                fill="#03D9AF"
            />
            <path
                d="M14.1138 4.17391L16.4231 0H11.8069L9.5 4.17391H14.1138Z"
                fill="#50FDDB"
            />
            <path
                d="M5.11378 4.17391L7.42308 0H2.80689L0.5 4.17391H5.11378Z"
                fill="#50FDDB"
            />
        </svg>
    ),
    verificationTick: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.389 24.2643C19.0733 24.2643 24.4919 18.8456 24.4919 12.1614C24.4919 5.47712 19.0733 0.0584717 12.389 0.0584717C5.70478 0.0584717 0.286133 5.47712 0.286133 12.1614C0.286133 18.8456 5.70478 24.2643 12.389 24.2643ZM18.1725 8.75136C18.5171 8.3425 18.4651 7.73166 18.0562 7.38702C17.6473 7.04239 17.0365 7.09445 16.6918 7.50332L9.78091 15.7022L7.07816 12.4958C6.73352 12.0869 6.12268 12.0348 5.71382 12.3795C5.30495 12.7241 5.25289 13.3349 5.59752 13.7438L9.04059 17.8285C9.22456 18.0468 9.49546 18.1727 9.78091 18.1727C10.0664 18.1727 10.3373 18.0468 10.5212 17.8285L18.1725 8.75136Z"
                fill="#A08CFF"
            />
        </svg>
    ),
    cross: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
        >
            <path
                d="M18.2772 8.82623L8.94336 18.3015M18.2772 18.3014L8.94336 8.82617"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    rangeArrow: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="30"
            viewBox="0 0 19 30"
            fill="none"
        >
            <line
                x1="9.55176"
                y1="8.05591"
                x2="9.55176"
                y2="29.2827"
                stroke="#A08CFF"
            />
            <path
                d="M10.5607 7.43878L17.2929 0.706543L1.70711 0.706546L8.43934 7.43878C9.02513 8.02456 9.97487 8.02456 10.5607 7.43878Z"
                fill="#A08CFF"
                stroke="#A08CFF"
            />
        </svg>
    ),
};
export const socialIcons = {
    twitter: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="17"
            viewBox="0 0 18 17"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.7431 9.01204L0 0.5H5.341L9.50346 5.76103L13.9504 0.523688H16.8919L10.9257 7.55865L18 16.5H12.675L8.16784 10.8105L3.35606 16.4843H0.398583L6.7431 9.01204ZM13.4511 14.9228L3.27493 2.07713H4.56424L14.7276 14.9228H13.4511Z"
                fill="currentColor"
            ></path>
        </svg>
    ),
    telegram: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.9593 16.3852L16.9599 16.3836L16.9775 16.3412L20 1.59794V1.55005C20 1.18271 19.8597 0.862027 19.5544 0.669671C19.2872 0.501301 18.98 0.48931 18.7647 0.505128C18.5369 0.521856 18.322 0.576869 18.1733 0.622662C18.0968 0.646221 18.0328 0.668921 17.987 0.68609C17.964 0.694707 17.9454 0.702019 17.9319 0.707467L17.9186 0.712886L1.06641 7.10877L1.06177 7.11038C1.05267 7.11359 1.04063 7.11793 1.0261 7.12341C0.997114 7.13432 0.957664 7.14994 0.91132 7.17026C0.820324 7.21016 0.694601 7.27173 0.567098 7.35621C0.350544 7.49968 -0.0618076 7.83935 0.00782129 8.37784C0.0654948 8.82388 0.383293 9.10716 0.597544 9.25383C0.712395 9.33245 0.822271 9.38914 0.902731 9.4262C0.943499 9.44498 0.978129 9.45936 1.00392 9.46952C1.01685 9.47462 1.02766 9.47869 1.03602 9.48176L1.04673 9.48563L1.05358 9.48809L4.00197 10.4484C3.99202 10.6274 4.01037 10.8099 4.05943 10.9899L5.53631 16.4101C5.71142 17.0528 6.31236 17.5005 6.99933 17.5C7.61509 17.4996 8.16121 17.1392 8.39322 16.6015L10.699 14.2162L14.6591 17.1535L14.7154 17.1773C15.0752 17.3292 15.4113 17.3773 15.7187 17.3367C16.0256 17.2962 16.2695 17.1716 16.4526 17.0298C16.6329 16.8903 16.7565 16.7328 16.8342 16.6142C16.8736 16.554 16.9031 16.5011 16.9235 16.4612C16.9337 16.4412 16.9418 16.4243 16.9479 16.4111L16.9555 16.3941L16.9582 16.3878L16.9593 16.3852ZM5.52131 10.617C5.48774 10.4939 5.54043 10.3638 5.65159 10.2955L15.6521 4.15124C15.6521 4.15124 16.2403 3.80575 16.2193 4.15124C16.2193 4.15124 16.3243 4.21225 16.0091 4.49673C15.7101 4.76691 8.88145 11.1454 8.19049 11.7908C8.1506 11.8281 8.1268 11.8708 8.11274 11.9227L6.99819 16.0373L5.52131 10.617Z"
                fill="currentColor"
            ></path>
        </svg>
    ),
};
export const footerSocialIcons = [
    {
        title: "twitter",
        img: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.7431 9.01204L0 0.5H5.341L9.50346 5.76103L13.9504 0.523688H16.8919L10.9257 7.55865L18 16.5H12.675L8.16784 10.8105L3.35606 16.4843H0.398583L6.7431 9.01204ZM13.4511 14.9228L3.27493 2.07713H4.56424L14.7276 14.9228H13.4511Z"
                    fill="#909090"
                />
            </svg>
        ),
        url: "https://twitter.com/vanarchain",
    },
    {
        title: "telegram",
        img: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9593 16.3852L16.9599 16.3836L16.9775 16.3412L20 1.59794V1.55005C20 1.18271 19.8597 0.862027 19.5544 0.669671C19.2872 0.501301 18.98 0.48931 18.7647 0.505128C18.5369 0.521856 18.322 0.576869 18.1733 0.622662C18.0968 0.646221 18.0328 0.668921 17.987 0.68609C17.964 0.694707 17.9454 0.702019 17.9319 0.707467L17.9186 0.712886L1.06641 7.10877L1.06177 7.11038C1.05267 7.11359 1.04063 7.11793 1.0261 7.12341C0.997114 7.13432 0.957664 7.14994 0.91132 7.17026C0.820324 7.21016 0.694601 7.27173 0.567098 7.35621C0.350544 7.49968 -0.0618076 7.83935 0.00782129 8.37784C0.0654948 8.82388 0.383293 9.10716 0.597544 9.25383C0.712395 9.33245 0.822271 9.38914 0.902731 9.4262C0.943499 9.44498 0.978129 9.45936 1.00392 9.46952C1.01685 9.47462 1.02766 9.47869 1.03602 9.48176L1.04673 9.48563L1.05358 9.48809L4.00197 10.4484C3.99202 10.6274 4.01037 10.8099 4.05943 10.9899L5.53631 16.4101C5.71142 17.0528 6.31236 17.5005 6.99933 17.5C7.61509 17.4996 8.16121 17.1392 8.39322 16.6015L10.699 14.2162L14.6591 17.1535L14.7154 17.1773C15.0752 17.3292 15.4113 17.3773 15.7187 17.3367C16.0256 17.2962 16.2695 17.1716 16.4526 17.0298C16.6329 16.8903 16.7565 16.7328 16.8342 16.6142C16.8736 16.554 16.9031 16.5011 16.9235 16.4612C16.9337 16.4412 16.9418 16.4243 16.9479 16.4111L16.9555 16.3941L16.9582 16.3878L16.9593 16.3852ZM5.52131 10.617C5.48774 10.4939 5.54043 10.3638 5.65159 10.2955L15.6521 4.15124C15.6521 4.15124 16.2403 3.80575 16.2193 4.15124C16.2193 4.15124 16.3243 4.21225 16.0091 4.49673C15.7101 4.76691 8.88145 11.1454 8.19049 11.7908C8.1506 11.8281 8.1268 11.8708 8.11274 11.9227L6.99819 16.0373L5.52131 10.617Z"
                    fill="#909090"
                />
            </svg>
        ),
        url: "https://t.me/vanarofficial",
    },
    {
        title: "medium",
        img: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <g clipPath="url(#clip0_7883_2967)">
                    <path
                        d="M13.2871 11.9881C13.2871 15.4009 10.5393 18.1674 7.14986 18.1674C3.76046 18.1674 1.01245 15.4009 1.01245 11.9881C1.01245 8.57537 3.76025 5.80859 7.14986 5.80859C10.5395 5.80859 13.2871 8.57537 13.2871 11.9881Z"
                        fill="#909090"
                    />
                    <path
                        d="M20.0197 11.988C20.0197 15.2003 18.6458 17.8055 16.951 17.8055C15.2562 17.8055 13.8823 15.2003 13.8823 11.988C13.8823 8.77559 15.256 6.17041 16.9508 6.17041C18.6456 6.17041 20.0195 8.77475 20.0195 11.988"
                        fill="#909090"
                    />
                    <path
                        d="M22.7736 11.988C22.7736 14.8655 22.2904 17.1996 21.6943 17.1996C21.0982 17.1996 20.6152 14.8661 20.6152 11.988C20.6152 9.10985 21.0984 6.77637 21.6943 6.77637C22.2902 6.77637 22.7736 9.10964 22.7736 11.988Z"
                        fill="#909090"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_7883_2967">
                        <rect
                            width="24"
                            height="24"
                            fill="white"
                        />
                    </clipPath>
                </defs>
            </svg>
        ),
        url: "https://medium.com/vanarchain",
    },
];
export const vanryLogo = {
    header: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="40"
            viewBox="0 0 46 40"
            fill="none"
        >
            <g clipPath="url(#clip0_14571_27613)">
                <path
                    d="M28.7448 39.6111L34.4925 29.7039L17.2493 0H5.74776L0 9.90129H11.5075L28.7448 39.6111ZM40.2463 19.8026L46 9.90129L40.2463 0H28.7507L23.003 9.90129H34.4985L40.2463 19.8026Z"
                    fill="#03D9AF"
                />
                <path
                    d="M34.9218 10.2222L40.8889 0H28.9609L23 10.2222H34.9218Z"
                    fill="#03D9AF"
                />
                <path
                    d="M11.9218 10.2222L17.8889 0H5.96089L0 10.2222H11.9218Z"
                    fill="#03D9AF"
                />
            </g>
            <defs>
                <clipPath id="clip0_14571_27613">
                    <rect
                        width="46"
                        height="39.6111"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    footer: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="39"
            viewBox="0 0 46 39"
            fill="none"
        >
            <g clipPath="url(#clip0_14675_5188)">
                <path
                    d="M28.7448 38.2376L34.4925 28.6739L17.2493 0H5.74776L0 9.55796H11.5075L28.7448 38.2376ZM40.2463 19.1159L46 9.55796L40.2463 0H28.7507L23.003 9.55796H34.4985L40.2463 19.1159Z"
                    fill="#03D9AF"
                />
                <path
                    d="M34.4925 9.55796L40.2463 0L28.7448 6.84744e-07L22.997 9.55796H34.4925Z"
                    fill="#03D9AF"
                />
                <path
                    d="M11.4955 9.55796L17.2493 0H5.74776L0 9.55796L11.4955 9.55796Z"
                    fill="#03D9AF"
                />
            </g>
            <defs>
                <clipPath id="clip0_14675_5188">
                    <rect
                        width="46"
                        height="38.2376"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    ),
    midFooter: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="632"
            height="194"
            viewBox="0 0 632 194"
            fill="none"
        >
            <path
                d="M394.867 535.148L473.776 401.498L237.05 0.790039H79.1516L0.243164 134.359H158.224L394.867 535.148ZM552.766 267.929L631.757 134.359L552.766 0.790039H394.949L316.041 134.359H473.858L552.766 267.929Z"
                fill="url(#paint0_linear_21738_18688)"
                fillOpacity="0.04"
            />
            <path
                d="M473.776 134.359L552.766 0.790039L394.867 0.790049L315.959 134.359H473.776Z"
                fill="url(#paint1_linear_21738_18688)"
                fillOpacity="0.04"
            />
            <path
                d="M158.06 134.359L237.05 0.790039H79.1516L0.243164 134.359L158.06 134.359Z"
                fill="url(#paint2_linear_21738_18688)"
                fillOpacity="0.04"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_21738_18688"
                    x1="316"
                    y1="0.790049"
                    x2="621.509"
                    y2="349.17"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="0.758629"
                        stopColor="#02735D"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_21738_18688"
                    x1="316"
                    y1="0.790049"
                    x2="621.509"
                    y2="349.17"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="0.758629"
                        stopColor="#02735D"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_21738_18688"
                    x1="316"
                    y1="0.790049"
                    x2="621.509"
                    y2="349.17"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="0.758629"
                        stopColor="#02735D"
                        stopOpacity="0"
                    />
                </linearGradient>
            </defs>
        </svg>
    ),
};
export const text = {
    SERVICE_AGGREEMENT:
        "I have read and agreed to VANAR Launchpool service agreement",
    NOTE: "Both pools offer the option to unstake before the period ends, albeit with a consequence; early unstakers forfeit their airdrop eligibility and incur a 2.5% penalty on their staked token amount, applying to both ERC20 and Vanar Chain tokens.",
    WALLET: "If you don’t have a wallet yet, you can select a provider and create one now.",
    COPY_RIGHT: "Copyright © 2024 Vanar Chain",
};
export const faqs = [
    {
        title: "Who is eligible for Vanar Launchpool?",
        description: `Only users who have completed the individual KYC L1
    requirement are eligible. Please note that enterprises are not
    eligible for the event. You can <a href='https://abc.com' target='_blank' rel='noreferrer'>
      click here </a>
     to complete the verification.`,
    },
    {
        title: "How can I participate in Vanar Launchpool?",
        description: `Simply go to the <a href='/' rel='noreferrer'>Launchpool homepage</a> and click
    on Register to participate in the relevant project. After
    successful registration, you can proceed to stake and earn
    tokens for the selected project.`,
    },
    {
        title: "How is my daily yield calculated?",
        description: `Your daily yield depends on the number of tokens you've staked
    to each pool in proportion to the total number of tokens
    staked to each pool by the respective participants. Once
    staked, your daily yield will be automatically calculated.`,
    },
    {
        title: "How can I participate in Vanar Launchpool?",
        description: `Simply go to the Launchpool homepage and click on Register to
    participate in the relevant project. After successful
    registration, you can proceed to stake and earn tokens for the
    selected project.`,
    },
    {
        title: "How is my daily yield calculated?",
        description: `Your daily yield depends on the number of tokens you've staked
    to each pool in proportion to the total number of tokens
    staked to each pool by the respective participants. Once
    staked, your daily yield will be automatically calculated.
    <div className='mt-4'></div>
    Let’s assume that you’ve staked token α to earn a new token β:
    Your daily yield for β = (the amount of α you’ve staked to the
    α pool / total number of α staked to the α pool by the all
    participants) * daily β prize pool
    <div className='mt-4'></div>
    Calculations for your yield will start on the next day (T+1)
    after you’ve staked tokens, and will be deposited daily to
    your Funding Account starting the day after the calculation
    period (T+2). Please note that no yield will be generated on
    the day you unstake your staked tokens and your yield will be
    refreshed daily at 00:00AM UTC.
    <div className='mt-4'></div>
    Your last daily yield and staked tokens will be automatically
    credited to your Funding Account two (2) days after the event
    ends. Please note that there may be delays in the depositing
    of yields earned. You will only receive a yield if it’s
    greater than or equal to $0.01 equivalent.`,
    },
    {
        title: " I am a VIP user. Are there any additional advantages when participating in Launchpool?",
        description: `VIP users participating in Launchpool will enjoy a higher
    estimated Annualized Percentage Rate (APR). For specific
    differences in the estimated APR, please refer to the
    respective product landing page.`,
    },
];

export const validatorCardIcons = {
    arrow: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M10 7L14 12L10 17"
                stroke="#FFF5F5"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    staked: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="33"
            viewBox="0 0 34 33"
            fill="none"
        >
            <circle
                cx="16.9999"
                cy="16.2787"
                r="16.2787"
                fill="#724AEE"
                fillOpacity="0.16"
            />
            <path
                d="M12.4824 18.0671H10.2235C9.54779 18.0671 9 18.6149 9 19.2907V23.0554C9 23.7311 9.54779 24.2789 10.2235 24.2789H12.4824C13.1581 24.2789 13.7059 23.7311 13.7059 23.0554V19.2907C13.7059 18.6149 13.1581 18.0671 12.4824 18.0671Z"
                fill="#A08CFF"
            />
            <path
                d="M18.1293 15.0552H15.8705C15.1948 15.0552 14.647 15.603 14.647 16.2787V23.0552C14.647 23.7309 15.1948 24.2787 15.8705 24.2787H18.1293C18.8051 24.2787 19.3529 23.7309 19.3529 23.0552V16.2787C19.3529 15.603 18.8051 15.0552 18.1293 15.0552Z"
                fill="#A08CFF"
            />
            <path
                d="M23.7763 12.0435H21.5175C20.8417 12.0435 20.2939 12.5912 20.2939 13.267V23.0552C20.2939 23.731 20.8417 24.2788 21.5175 24.2788H23.7763C24.452 24.2788 24.9998 23.731 24.9998 23.0552V13.267C24.9998 12.5912 24.452 12.0435 23.7763 12.0435Z"
                fill="#A08CFF"
            />
            <path
                d="M21.3637 8.52691C21.285 8.44825 21.1916 8.38586 21.0889 8.34329C20.9861 8.30072 20.8759 8.27881 20.7647 8.27881C20.6535 8.27881 20.5433 8.30072 20.4405 8.34329C20.3378 8.38586 20.2444 8.44825 20.1657 8.52691L16.8328 11.8598L14.367 10.6269C14.2493 10.5684 14.1197 10.5378 13.9882 10.5376C13.8769 10.5372 13.7666 10.5589 13.6638 10.6015C13.561 10.6441 13.4676 10.7067 13.3893 10.7857L10.3775 13.7975C10.2186 13.9564 10.1294 14.1718 10.1294 14.3965C10.1294 14.6211 10.2186 14.8366 10.3775 14.9954C10.5363 15.1543 10.7518 15.2435 10.9765 15.2435C11.2011 15.2435 11.4166 15.1543 11.5754 14.9954L14.1554 12.4155L16.6235 13.6484C16.7405 13.7067 16.8693 13.7372 17 13.7376C17.1113 13.738 17.2215 13.7162 17.3243 13.6736C17.4271 13.631 17.5205 13.5685 17.599 13.4895L21.3637 9.72484C21.5222 9.56584 21.6113 9.35044 21.6113 9.12587C21.6113 8.90131 21.5222 8.68591 21.3637 8.52691Z"
                fill="#A08CFF"
            />
        </svg>
    ),
};
export const validatorListIcons = {
    arrow: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
        >
            <g opacity="0.24">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.20052 0.38208L3.45077 3.22496L0.700684 6.06783H6.20052H11.7007L8.9506 3.22496L6.20052 0.38208Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.9506 11.5614L11.7007 8.81787H6.20052H0.700684L3.45077 11.5614L6.20052 14.3483L8.9506 11.5614Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    ),
    verificationTick: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <path
                d="M16.0807 9.06625C15.8141 8.40872 15.8141 7.68011 16.0807 7.04036L16.1695 6.82711C16.7382 5.47652 16.0807 3.91267 14.7301 3.344L14.5346 3.25515C13.8771 2.98858 13.3617 2.47323 13.0951 1.8157L13.0241 1.63799C12.4376 0.287401 10.8915 -0.352353 9.52318 0.198546L9.34547 0.26963C8.68794 0.536194 7.95934 0.536194 7.30181 0.26963L7.14187 0.198546C5.80905 -0.352353 4.24521 0.305172 3.67654 1.65576L3.60546 1.79793C3.33889 2.45546 2.82353 2.97081 2.16601 3.23738L2.00607 3.30846C0.673249 3.87713 0.0157244 5.44097 0.584395 6.79157L0.655478 6.9515C0.922043 7.60903 0.922043 8.33764 0.655478 8.97739L0.584395 9.17287C0.0157244 10.5235 0.655478 12.0873 2.02384 12.6382L2.20155 12.7093C2.85908 12.9759 3.37443 13.4912 3.641 14.1487L3.72985 14.3442C4.28075 15.7126 5.84459 16.3523 7.19519 15.8014L7.39067 15.7126C8.04819 15.446 8.7768 15.446 9.43432 15.7126L9.59426 15.7837C10.9449 16.3523 12.5087 15.6948 13.0774 14.3442L13.1485 14.202C13.415 13.5445 13.9304 13.0292 14.5879 12.7626L14.7301 12.7093C16.0984 12.1406 16.7382 10.5945 16.1695 9.22619L16.0807 9.06625ZM7.62169 11.4653L4.15635 8.55089L5.22261 7.28915L7.42621 9.1551L11.318 4.53466L12.5798 5.60091L7.62169 11.4653Z"
                fill="#50FDDB"
            />
        </svg>
    ),
    rightArrow: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
        >
            <circle
                cx="15"
                cy="15"
                r="15"
                fill="#50FDDB"
                fillOpacity="0.08"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.4419 15.4421C20.686 15.198 20.686 14.8023 20.4419 14.5582L17.1086 11.2249C16.8645 10.9808 16.4688 10.9808 16.2247 11.2249C15.9806 11.469 15.9806 11.8647 16.2247 12.1088L18.4911 14.3752H10C9.65482 14.3752 9.375 14.655 9.375 15.0002C9.375 15.3453 9.65482 15.6252 10 15.6252H18.4911L16.2247 17.8916C15.9806 18.1356 15.9806 18.5314 16.2247 18.7754C16.4688 19.0195 16.8645 19.0195 17.1086 18.7754L20.4419 15.4421Z"
                fill="#50FDDB"
            />
        </svg>
    ),
};
export const requirementCardIcons = {
    hardware: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="38"
            height="33"
            viewBox="0 0 38 33"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.84356 4.5H29.5726C30.4822 4.5 31.3545 4.81433 31.9976 5.37384C32.6408 5.93334 33.0021 6.6922 33.0021 7.48346V25.5165C33.0021 26.3078 32.6408 27.0667 31.9976 27.6262C31.3545 28.1857 30.4822 28.5 29.5726 28.5H8.84356C7.934 28.5 7.06169 28.1857 6.41854 27.6262C5.77538 27.0667 5.41406 26.3078 5.41406 25.5165V7.48346C5.41406 6.6922 5.77538 5.93334 6.41854 5.37384C7.06169 4.81433 7.934 4.5 8.84356 4.5ZM10.3202 3.72019V0.889904C10.3202 0.786495 10.3674 0.687322 10.4515 0.6142C10.5355 0.541079 10.6495 0.5 10.7684 0.5C10.8873 0.5 11.0013 0.541079 11.0853 0.6142C11.1694 0.687322 11.2166 0.786495 11.2166 0.889904V3.72019H10.3202ZM4.51767 9.53742H1.26425C1.14538 9.53742 1.03138 9.49634 0.947329 9.42322C0.863276 9.3501 0.816055 9.25093 0.816055 9.14752C0.816055 9.04411 0.863276 8.94494 0.947329 8.87182C1.03138 8.7987 1.14538 8.75762 1.26425 8.75762H4.51767V9.53742ZM4.51767 13.2102H1.26425C1.15217 13.201 1.04807 13.1557 0.972305 13.0833C0.896536 13.0109 0.854546 12.9165 0.854546 12.8185C0.854546 12.7206 0.896536 12.6262 0.972305 12.5538C1.04807 12.4813 1.15217 12.4361 1.26425 12.4269H4.51767V13.2102ZM4.51767 16.8795H1.26425C1.14538 16.8795 1.03138 16.8384 0.947329 16.7653C0.863276 16.6921 0.816055 16.593 0.816055 16.4896C0.816055 16.3861 0.863276 16.287 0.947329 16.2139C1.03138 16.1407 1.14538 16.0997 1.26425 16.0997H4.51767V16.8795ZM4.51767 20.5522H1.26425C1.15217 20.543 1.04807 20.4978 0.972305 20.4253C0.896536 20.3529 0.854546 20.2585 0.854546 20.1606C0.854546 20.0626 0.896536 19.9682 0.972305 19.8958C1.04807 19.8234 1.15217 19.7781 1.26425 19.7689H4.51767V20.5522ZM4.51767 24.2215H1.26425C1.20539 24.2215 1.14711 24.2114 1.09273 24.1918C1.03836 24.1722 0.988947 24.1435 0.947329 24.1073C0.90571 24.0711 0.872696 24.0281 0.850172 23.9808C0.827648 23.9335 0.816055 23.8828 0.816055 23.8316C0.816055 23.7804 0.827648 23.7297 0.850172 23.6824C0.872696 23.6351 0.90571 23.5921 0.947329 23.5559C0.988947 23.5197 1.03836 23.491 1.09273 23.4714C1.14711 23.4518 1.20539 23.4417 1.26425 23.4417H4.51767V24.2215ZM11.2206 29.2798V32.1101C11.2206 32.2135 11.1734 32.3127 11.0893 32.3858C11.0053 32.4589 10.8913 32.5 10.7724 32.5C10.6535 32.5 10.5395 32.4589 10.4555 32.3858C10.3714 32.3127 10.3242 32.2135 10.3242 32.1101V29.2798H11.2206ZM15.4424 29.2798V32.1101C15.4424 32.2135 15.3952 32.3127 15.3112 32.3858C15.2271 32.4589 15.1131 32.5 14.9942 32.5C14.8754 32.5 14.7614 32.4589 14.6773 32.3858C14.5933 32.3127 14.546 32.2135 14.546 32.1101V29.2798H15.4424ZM19.6603 29.2798V32.1101C19.6603 32.2135 19.6131 32.3127 19.529 32.3858C19.4449 32.4589 19.3309 32.5 19.2121 32.5C19.0932 32.5 18.9792 32.4589 18.8952 32.3858C18.8111 32.3127 18.7639 32.2135 18.7639 32.1101V29.2798H19.6603ZM23.8821 29.2798V32.1101C23.8715 32.2076 23.8195 32.2982 23.7363 32.3641C23.653 32.43 23.5445 32.4665 23.4319 32.4665C23.3193 32.4665 23.2108 32.43 23.1276 32.3641C23.0443 32.2982 22.9923 32.2076 22.9817 32.1101V29.2798H23.8821ZM28.1 29.2798V32.1101C28.1 32.1613 28.0884 32.212 28.0658 32.2593C28.0433 32.3066 28.0103 32.3496 27.9687 32.3858C27.9271 32.422 27.8777 32.4507 27.8233 32.4703C27.7689 32.4899 27.7106 32.5 27.6518 32.5C27.5929 32.5 27.5346 32.4899 27.4802 32.4703C27.4259 32.4507 27.3765 32.422 27.3348 32.3858C27.2932 32.3496 27.2602 32.3066 27.2377 32.2593C27.2152 32.212 27.2036 32.1613 27.2036 32.1101V29.2798H28.1ZM33.9025 23.4626H37.1839C37.3028 23.4626 37.4168 23.5037 37.5008 23.5768C37.5849 23.6499 37.6321 23.7491 37.6321 23.8525C37.6321 23.9559 37.5849 24.0551 37.5008 24.1282C37.4168 24.2013 37.3028 24.2424 37.1839 24.2424H33.9025V23.4626ZM33.9025 19.7898H37.1839C37.296 19.799 37.4001 19.8443 37.4759 19.9167C37.5516 19.9891 37.5936 20.0835 37.5936 20.1815C37.5936 20.2794 37.5516 20.3738 37.4759 20.4462C37.4001 20.5187 37.296 20.5639 37.1839 20.5731H33.9025V19.7794V19.7898ZM33.9025 16.1205H37.1839C37.3028 16.1205 37.4168 16.1616 37.5008 16.2347C37.5849 16.3079 37.6321 16.407 37.6321 16.5104C37.6321 16.6139 37.5849 16.713 37.5008 16.7861C37.4168 16.8593 37.3028 16.9003 37.1839 16.9003H33.9025V16.1101V16.1205ZM33.9025 12.4478H37.1839C37.296 12.457 37.4001 12.5022 37.4759 12.5747C37.5516 12.6471 37.5936 12.7415 37.5936 12.8394C37.5936 12.9374 37.5516 13.0318 37.4759 13.1042C37.4001 13.1766 37.296 13.2219 37.1839 13.2311H33.9025V12.4373V12.4478ZM33.9025 8.7785H37.1839C37.3028 8.7785 37.4168 8.81958 37.5008 8.8927C37.5849 8.96583 37.6321 9.065 37.6321 9.16841C37.6321 9.27182 37.5849 9.37099 37.5008 9.44411C37.4168 9.51723 37.3028 9.55831 37.1839 9.55831H33.9025V8.76806V8.7785ZM27.1996 3.72019V0.889904C27.1996 0.786495 27.2468 0.687322 27.3308 0.6142C27.4149 0.541079 27.5289 0.5 27.6478 0.5C27.7666 0.5 27.8806 0.541079 27.9647 0.6142C28.0487 0.687322 28.096 0.786495 28.096 0.889904V3.72019H27.1996ZM22.9777 3.72019V0.889904C22.9883 0.792405 23.0403 0.701844 23.1236 0.635928C23.2068 0.570013 23.3153 0.533484 23.4279 0.533484C23.5405 0.533484 23.649 0.570013 23.7323 0.635928C23.8155 0.701844 23.8675 0.792405 23.8781 0.889904V3.72019H22.9777ZM18.7599 3.72019V0.889904C18.7599 0.786495 18.8071 0.687322 18.8912 0.6142C18.9752 0.541079 19.0892 0.5 19.2081 0.5C19.3269 0.5 19.4409 0.541079 19.525 0.6142C19.6091 0.687322 19.6563 0.786495 19.6563 0.889904V3.72019H18.7599ZM14.542 3.72019V0.889904C14.542 0.786495 14.5893 0.687322 14.6733 0.6142C14.7574 0.541079 14.8714 0.5 14.9902 0.5C15.1091 0.5 15.2231 0.541079 15.3072 0.6142C15.3912 0.687322 15.4384 0.786495 15.4384 0.889904V3.72019H14.542ZM9.61989 8.14491V24.8551H28.8283V8.14491H9.61989ZM8.7035 25.2485C8.7035 25.3519 8.75072 25.4511 8.83477 25.5242C8.91882 25.5973 9.03282 25.6384 9.15169 25.6384H29.2645C29.3833 25.6384 29.4973 25.5973 29.5814 25.5242C29.6654 25.4511 29.7127 25.3519 29.7127 25.2485V7.75152C29.7127 7.64812 29.6654 7.54894 29.5814 7.47582C29.4973 7.4027 29.3833 7.36162 29.2645 7.36162H9.15169C9.03282 7.36162 8.91882 7.4027 8.83477 7.47582C8.75072 7.54894 8.7035 7.64812 8.7035 7.75152V25.2485Z"
                fill="#50FDDB"
            />
        </svg>
    ),
    software: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="38"
            height="17"
            viewBox="0 0 38 17"
            fill="none"
        >
            <path
                d="M8.24335 14.9037C7.75419 14.9042 7.2854 14.7355 6.94007 14.4349L1.40965 9.63495C1.06369 9.33495 0.869568 8.92805 0.869568 8.5038C0.869568 8.07955 1.06369 7.67237 1.40965 7.37238L6.94007 2.57239C7.40669 2.17248 8.08289 2.01793 8.71588 2.16658C9.34916 2.31498 9.84354 2.74408 10.0146 3.29376C10.1859 3.84313 10.0075 4.42998 9.54672 4.83503L5.3199 8.50387L9.54704 12.1727C9.89238 12.4727 10.0865 12.8796 10.0865 13.3039C10.0865 13.7281 9.89238 14.135 9.54673 14.4353C9.20108 14.7353 8.73216 14.9037 8.24335 14.9037ZM31.6686 14.4349L37.1991 9.63495C37.545 9.33495 37.7391 8.92805 37.7391 8.5038C37.7391 8.07955 37.545 7.67237 37.1991 7.37238L31.6686 2.57239C31.202 2.17248 30.5258 2.01793 29.8928 2.16658C29.2595 2.31498 28.7652 2.74408 28.5941 3.29376C28.4228 3.84313 28.6012 4.42998 29.062 4.83503L33.2888 8.50387L29.0617 12.1727C28.7126 12.4719 28.5154 12.8798 28.5139 13.306C28.5123 13.7319 28.7065 14.1409 29.0536 14.4422C29.4008 14.7435 29.8721 14.912 30.3628 14.9107C30.8538 14.9094 31.3239 14.7382 31.6686 14.4349ZM17.2666 15.6194L24.6404 2.81918C24.8605 2.43962 24.8978 1.99927 24.7435 1.59586C24.5892 1.19247 24.2562 0.858998 23.8183 0.668781C23.38 0.478873 22.873 0.447796 22.4085 0.582799C21.944 0.717527 21.5604 1.00735 21.3425 1.38796L13.9687 14.1882C13.6759 14.6995 13.7191 15.307 14.082 15.783C14.4446 16.259 15.072 16.5314 15.7288 16.4976C16.3852 16.4639 16.9713 16.1294 17.2666 15.6194Z"
                fill="#50FDDB"
            />
        </svg>
    ),
    network: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="29"
            viewBox="0 0 36 29"
            fill="none"
        >
            <path
                d="M4.67867 20.6344V17.6866C4.67867 16.5826 5.1962 15.5816 6.03024 14.856C6.86432 14.1304 8.01494 13.6802 9.28395 13.6802H17.4168V10.5025H15.6881C14.8032 10.5025 13.9993 10.1888 13.4172 9.68354C12.8364 9.17827 12.4744 8.4778 12.4744 7.70791V3.29462C12.4744 2.52353 12.8349 1.82546 13.4172 1.31899C13.998 0.813725 14.8018 0.5 15.6881 0.5H20.7627C21.6476 0.5 22.4515 0.813694 23.0336 1.31899C23.6144 1.82426 23.9764 2.52353 23.9764 3.29462V7.70791C23.9764 8.4778 23.6159 9.17707 23.0336 9.68354C22.4528 10.1888 21.649 10.5025 20.7627 10.5025H19.034V20.6346H19.5322C20.4172 20.6346 21.221 20.9483 21.8032 21.4548C22.384 21.9601 22.746 22.6593 22.746 23.4304V25.7054C22.746 26.4765 22.3854 27.1745 21.8032 27.681C21.2224 28.1863 20.4186 28.5 19.5322 28.5H16.9171C16.0321 28.5 15.2283 28.1863 14.6462 27.681C14.0653 27.1757 13.7033 26.4765 13.7033 25.7054V23.4304C13.7033 22.6605 14.0639 21.9613 14.6462 21.4548C15.227 20.9495 16.0308 20.6346 16.9171 20.6346H17.4154V15.0884H9.28251C8.45946 15.0884 7.71347 15.3794 7.17255 15.8511C6.63163 16.3217 6.2958 16.9718 6.2958 17.6867V20.6345H6.79406C7.67905 20.6345 8.48286 20.9482 9.06504 21.4547C9.64585 21.96 10.0079 22.6593 10.0079 23.4303V25.7053C10.0079 26.4764 9.64726 27.1745 9.06504 27.6809C8.48423 28.1862 7.68042 28.4999 6.79406 28.4999H4.17897C3.29398 28.4999 2.49017 28.1862 1.90799 27.6809C1.32718 27.1757 0.966553 26.4764 0.966553 25.7053V23.4303C0.966553 22.6605 1.32714 21.9612 1.90799 21.4547C2.4888 20.9495 3.29398 20.6345 4.17897 20.6345L4.67867 20.6344ZM29.6541 20.6344H30.1524V17.6866C30.1524 16.9706 29.8179 16.3216 29.2756 15.851C28.7347 15.3805 27.9887 15.0883 27.1656 15.0883H24.3827C23.9367 15.0883 23.5734 14.7734 23.5734 14.3843C23.5734 13.9951 23.9353 13.6802 24.3827 13.6802H27.1656C28.4347 13.6802 29.5853 14.1304 30.4194 14.856C31.2534 15.5816 31.7709 16.5826 31.7709 17.6865V20.6344H32.2692C33.1542 20.6344 33.958 20.9481 34.5402 21.4546C35.121 21.9599 35.4816 22.6591 35.4816 23.4302V25.7052C35.4816 26.4763 35.121 27.1744 34.5402 27.6808C33.9594 28.1861 33.1542 28.4998 32.2692 28.4998H29.6541C28.7691 28.4998 27.9653 28.1861 27.3831 27.6808C26.8023 27.1756 26.4403 26.4763 26.4403 25.7052V23.4302C26.4403 22.6603 26.8009 21.9611 27.3831 21.4546C27.9639 20.9493 28.7677 20.6344 29.6541 20.6344Z"
                fill="#50FDDB"
            />
        </svg>
    ),
    financial: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="29"
            viewBox="0 0 33 29"
            fill="none"
        >
            <path
                d="M32.3311 4.86137C32.3311 5.84579 31.4291 6.73053 29.9186 7.49065C27.5171 8.51596 24.8959 9.0932 22.2231 9.18536C21.9868 9.08567 21.7577 8.99221 21.5072 8.91122C18.5382 7.92356 15.3789 7.44131 12.2009 7.49065C11.6783 7.49065 11.1629 7.49065 10.6546 7.52181L10.5831 7.49065C9.07257 6.75545 8.17058 5.84579 8.17058 4.86137C8.17058 2.44393 13.5825 0.5 20.2544 0.5C26.9263 0.5 32.3311 2.44393 32.3311 4.86137ZM10.2251 9.30374C10.8694 9.26636 11.528 9.24143 12.2009 9.24143C16.1095 9.24143 19.5815 9.91433 21.7935 10.9611C23.3828 11.7025 24.2776 12.6308 24.2776 13.6215C24.2757 13.834 24.2321 14.0448 24.1487 14.2445C23.7061 15.1045 22.9274 15.7999 21.951 16.2072H21.9009C19.696 17.2726 16.174 17.9642 12.2367 17.9642C9.03742 18.0363 5.85941 17.4917 2.93043 16.3692C2.81283 16.3202 2.69815 16.2662 2.58681 16.2072C1.01906 15.5156 0.117065 14.6121 0.117065 13.6215C0.117065 11.7212 3.47448 10.0888 8.17058 9.49688C8.82917 9.40966 9.51641 9.34735 10.2251 9.30374ZM26.2892 13.6215C26.2728 13.071 26.1301 12.5289 25.8695 12.027C25.6088 11.5252 25.2355 11.0738 24.7715 10.6994C26.4152 10.49 28.025 10.1136 29.5679 9.57788C30.5614 9.23104 31.4921 8.76096 32.3311 8.18224V10.1386C32.3311 11.1978 31.2931 12.1698 29.575 12.9237C28.5137 13.3675 27.3966 13.702 26.2462 13.9206C26.2462 13.8209 26.2462 13.7274 26.2462 13.6277L26.2892 13.6215ZM24.2776 18.8614C24.2776 19.8458 23.3756 20.7305 21.8651 21.4907L21.5144 21.6464C19.3023 22.6246 15.9449 23.2414 12.2081 23.2414C8.24932 23.2601 4.77021 22.5997 2.52954 21.5093C1.01906 20.7741 0.117065 19.8645 0.117065 18.8614V16.9424C0.955286 17.522 1.88617 17.9922 2.88031 18.338C5.84984 19.324 9.00877 19.8062 12.1866 19.7586C15.3644 19.8065 18.5234 19.3243 21.4929 18.338C21.9852 18.1577 22.4635 17.9496 22.9246 17.715C23.3005 17.5285 23.6617 17.3204 24.0056 17.0919L24.2776 16.905V18.8614ZM26.2892 18.8614V15.7087C27.4092 15.5017 28.5063 15.2099 29.5679 14.8364C30.5631 14.4899 31.4942 14.0176 32.3311 13.4346V15.3785C32.3119 15.7001 32.2191 16.0152 32.058 16.3051C31.897 16.5951 31.671 16.8541 31.3933 17.067C30.3696 17.9579 28.5656 18.6931 26.2749 19.1729C26.282 19.0794 26.2892 18.9797 26.2892 18.8614ZM12.2009 25.0171C15.3788 25.0651 18.5378 24.5829 21.5072 23.5966C22.5008 23.2497 23.4315 22.7797 24.2704 22.2009V24.1386C24.2704 26.5561 18.8585 28.5 12.1938 28.5C5.52903 28.5 0.117065 26.5561 0.117065 24.1386V22.2009C0.957036 22.7784 1.88753 23.2483 2.88031 23.5966C5.85433 24.5842 9.01829 25.0664 12.2009 25.0171Z"
                fill="#50FDDB"
            />
        </svg>
    ),
};

export const delegateStepsIcon = {
    connectWallet: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.5 0C4.04131 0 2.64236 0.579463 1.61091 1.61091C0.579463 2.64236 0 4.04131 0 5.5L0 16.5C0 17.9587 0.579463 19.3576 1.61091 20.3891C2.64236 21.4205 4.04131 22 5.5 22H16.5C17.9587 22 19.3576 21.4205 20.3891 20.3891C21.4205 19.3576 22 17.9587 22 16.5V5.5C22 4.04131 21.4205 2.64236 20.3891 1.61091C19.3576 0.579463 17.9587 0 16.5 0L5.5 0ZM5.5 6.53125C5.5 6.25775 5.60865 5.99544 5.80205 5.80205C5.99544 5.60865 6.25775 5.5 6.53125 5.5H15.4688C15.7423 5.5  16.0046 5.60865 16.198 5.80205C16.3913 5.99544 16.5 6.25775 16.5 6.53125C16.5 6.80475 16.3913 7.06706 16.198 7.26045C16.0046 7.45385 15.7423 7.5625 15.4688 7.5625H6.53125C6.25775 7.5625 5.99544 7.45385 5.80205 7.26045C5.60865 7.06706 5.5 6.80475 5.5 6.53125ZM18.9475 14.3963C19.1406 14.5896 19.2491 14.8517 19.2491 15.125C19.2491 15.3983 19.1406 15.6604 18.9475 15.8537L15.8537 18.9475C15.6604 19.1406 15.3983 19.2491 15.125 19.2491C14.8517 19.2491 14.5896 19.1406 14.3963 18.9475L12.6775 17.2288C12.5762 17.1343 12.4949 17.0205 12.4386 16.894C12.3822 16.7675 12.3519 16.6309 12.3494 16.4925C12.347 16.354 12.3725 16.2165 12.4243 16.0881C12.4762 15.9596 12.5534 15.843 12.6513 15.7451C12.7492 15.6471 12.8659 15.5699 12.9943 15.5181C13.1227 15.4662 13.2603 15.4407 13.3987 15.4432C13.5372 15.4456 13.6737 15.4759 13.8002 15.5323C13.9267 15.5887 14.0406 15.6699 14.135 15.7713L15.125 16.7612L17.49 14.3963C17.6834 14.2031 17.9455 14.0947 18.2188 14.0947C18.492 14.0947 18.7541 14.2031 18.9475 14.3963ZM5.5 11C5.5 10.7265 5.60865 10.4642 5.80205 10.2708C5.99544 10.0774 6.25775 9.96875 6.53125 9.96875H15.4688C15.7423 9.96875 16.0046 10.0774 16.198 10.2708C16.3913 10.4642 16.5 10.7265 16.5 11C16.5 11.2735 16.3913 11.5358 16.198 11.7292C16.0046 11.9226 15.7423 12.0312 15.4688 12.0312H6.53125C6.25775 12.0312 5.99544 11.9226 5.80205 11.7292C5.60865 11.5358 5.5 11.2735 5.5 11ZM5.5 15.4688C5.5 15.1952 5.60865 14.9329 5.80205 14.7395C5.99544 14.5462 6.25775 14.4375 6.53125 14.4375H9.96875C10.2423 14.4375 10.5046 14.5462 10.698 14.7395C10.8914 14.9329 11 15.1952 11 15.4688C11 15.7423 10.8914 16.0046 10.698 16.198C10.5046 16.3913 10.2423 16.5 9.96875 16.5H6.53125C6.25775 16.5 5.99544 16.3913 5.80205 16.198C5.60865 16.0046 5.5 15.7423 5.5 15.4688Z"
                fill="currentColor"
            />
        </svg>
    ),
    enterStake: (
        <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22 3.42679C22 4.20027 21.384 4.89542 20.3524 5.49266C18.7124 6.29826 16.9222 6.7518 15.0969 6.82421C14.9356 6.74588 14.7791 6.67245 14.608 6.60881C12.5804 5.8328 10.4228 5.45389 8.25244 5.49266C7.89556 5.49266 7.54356 5.49266 7.19644 5.51713L7.14756 5.49266C6.116 4.915 5.5 4.20027 5.5 3.42679C5.5 1.52737 9.196 0 13.7524 0C18.3089 0 22 1.52737 22 3.42679ZM6.90311 6.91722C7.34311 6.88785 7.79289 6.86827 8.25244 6.86827C10.9218 6.86827 13.2929 7.39697 14.8036 8.2194C15.8889 8.80196 16.5 9.53137 16.5 10.3097C16.4987 10.4767 16.4689 10.6423 16.412 10.7993C16.1097 11.475 15.5779 12.0214 14.9111 12.3413H14.8769C13.3711 13.1785 10.9658 13.7219 8.27689 13.7219C6.092 13.7786 3.92163 13.3506 1.92133 12.4686C1.84103 12.4302 1.7627 12.3877 1.68667 12.3413C0.616 11.798 0 11.0881 0 10.3097C0 8.81664 2.29289 7.53404 5.5 7.06898C5.94978 7.00044 6.41911 6.95149 6.90311 6.91722ZM17.8738 10.3097C17.8626 9.87719 17.7651 9.45124 17.5871 9.05695C17.4091 8.66266 17.1542 8.30799 16.8373 8.01379C17.9598 7.8493 19.0592 7.55355 20.1129 7.13262C20.7914 6.8601 21.427 6.49076 22 6.03605V7.57321C22 8.40543 21.2911 9.16911 20.1178 9.76146C19.393 10.1102 18.6301 10.373 17.8444 10.5447C17.8444 10.4664 17.8444 10.393 17.8444 10.3146L17.8738 10.3097ZM16.5 14.4268C16.5 15.2003 15.884 15.8954 14.8524 16.4927L14.6129 16.615C13.1022 17.3836 10.8093 17.8683 8.25733 17.8683C5.55378 17.883 3.17778 17.364 1.64756 16.5073C0.616 15.9297 0 15.215 0 14.4268V12.919C0.572448 13.3745 1.20818 13.7439 1.88711 14.0156C3.9151 14.7903 6.07243 15.1692 8.24267 15.1317C10.4129 15.1694 12.5703 14.7905 14.5982 14.0156C14.9345 13.8739 15.2611 13.7104 15.576 13.526C15.8327 13.3796 16.0794 13.216 16.3142 13.0365L16.5 12.8896V14.4268ZM17.8738 14.4268V11.9497C18.6387 11.7871 19.3879 11.5578 20.1129 11.2644C20.7926 10.9921 21.4285 10.6209 22 10.1629V11.6903C21.9869 11.943 21.9235 12.1905 21.8135 12.4183C21.7035 12.6461 21.5492 12.8496 21.3596 13.0169C20.6604 13.717 19.4284 14.2946 17.864 14.6716C17.8689 14.5981 17.8738 14.5198 17.8738 14.4268ZM8.25244 19.2635C10.4227 19.3011 12.5801 18.9223 14.608 18.1473C15.2865 17.8748 15.9222 17.5054 16.4951 17.0507V18.5732C16.4951 20.4726 12.7991 22 8.24756 22C3.696 22 0 20.4726 0 18.5732V17.0507C0.573643 17.5044 1.20911 17.8737 1.88711 18.1473C3.91816 18.9233 6.07893 19.3022 8.25244 19.2635Z"
                fill="currentColor"
            />
        </svg>
    ),
    terms: (
        <svg
            width="20"
            height="26"
            viewBox="0 0 20 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.57963 0.572825C9.8515 0.475725 10.1485 0.475725 10.4204 0.572825L19.1704 3.69782C19.6679 3.8755 20 4.34674 20 4.875V15.8952C20 18.0219 18.9186 20.0026 17.1297 21.1526L10.676 25.3015C10.2642 25.5661 9.73588 25.5661 9.324 25.3015L2.87026 21.1526C1.08137 20.0026 0 18.0219 0 15.8952V4.875C0 4.34674 0.332088 3.8755 0.829575 3.69782L9.57963 0.572825ZM14.6339 11.3839C15.122 10.8957 15.122 10.1043 14.6339 9.61611C14.1458 9.12796 13.3542 9.12796 12.8661 9.61611L8.75 13.7322L7.13389 12.1161C6.64573 11.628 5.85427 11.628 5.36611 12.1161C4.87796 12.6042 4.87796 13.3957 5.36611 13.8839L7.86613 16.3839C8.35425 16.872 9.14575 16.872 9.63387 16.3839L14.6339 11.3839Z"
                fill="currentColor"
            />
        </svg>
    ),
    deposit: (
        <svg
            width="24"
            height="21"
            viewBox="0 0 24 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.60032 13.6779V18.5701C1.3798 17.2418 9.60296e-05 15.3933 9.60296e-05 13.3511V10.3062C0.728956 11.6181 1.98188 12.7758 3.60032 13.6779ZM4.31538 18.9649C5.20384 19.4173 6.20039 19.7943 7.27859 20.0758V15.1105C6.21168 14.8404 5.21638 14.4822 4.31538 14.0486V18.9649ZM7.99378 20.2467C9.14112 20.4955 10.3664 20.6388 11.6432 20.6627V15.6813C10.3715 15.6587 9.14749 15.5192 7.99507 15.2767L7.99378 20.2467ZM12.3568 20.6627C13.6336 20.64 14.8613 20.4955 16.0088 20.2467V15.2753C14.8552 15.5179 13.6299 15.6586 12.3568 15.6812V20.6627ZM16.7236 20.0758C17.8006 19.7943 18.7959 19.4185 19.6831 18.9662V14.0489C18.7833 14.4812 17.788 14.8393 16.7236 15.1095V20.0758ZM20.3982 13.678V18.5702C22.6187 17.2419 23.9997 15.3921 23.9997 13.3499V10.305C23.2708 11.6182 22.0166 12.7758 20.3982 13.678ZM19.9081 13.1515C19.8993 13.1552 19.893 13.1603 19.8842 13.164C17.7743 14.2888 15.0158 14.9724 11.9998 14.9724C8.9863 14.9724 6.23159 14.29 4.12183 13.1678C4.10927 13.1615 4.09921 13.154 4.08665 13.1489C1.58463 11.8068 0 9.84276 0 7.65483C0 3.62095 5.38345 0.33728 12 0.33728C18.6166 0.33728 24 3.61966 24 7.65483C24 9.84395 22.4139 11.8093 19.9081 13.1515ZM21.7529 6.90456C20.3228 4.27811 16.4032 2.51261 12 2.51261C7.59679 2.51261 3.67711 4.27698 2.24712 6.90456C2.15287 7.07798 2.21696 7.29537 2.39038 7.38963C2.5638 7.48513 2.78119 7.41979 2.87545 7.24637C4.18364 4.84235 7.85066 3.2276 12 3.2276C16.1494 3.2276 19.8166 4.84241 21.1259 7.24637C21.1912 7.36575 21.3131 7.43235 21.4401 7.43235C21.4979 7.43235 21.5557 7.41853 21.611 7.38837C21.7844 7.29538 21.8484 7.07798 21.7529 6.90456Z"
                fill="currentColor"
            />
        </svg>
    ),
    confirm: (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 0C5.38105 0 0 5.38105 0 12C0 18.6189 5.38105 24 12 24C18.6189 24 24 18.6189 24 12C24 5.38105 18.6189 0 12 0ZM19.7558 7.4021L9.65053 17.5074C9.52421 17.6337 9.37263 17.6842 9.19579 17.6842C9.04421 17.6842 8.86737 17.6337 8.74105 17.5074L4.24421 13.0105C3.99158 12.7579 3.99158 12.3537 4.24421 12.1263C4.49684 11.8737 4.90105 11.8737 5.12842 12.1263L9.17053 16.1684L18.8211 6.51789C19.0737 6.26526 19.4779 6.26526 19.7053 6.51789C19.9832 6.74526 19.9832 7.14947 19.7558 7.4021Z"
                fill="currentColor"
            />
        </svg>
    ),
};

export const errorTexts = {
    unknown: "Something went wrong please try again later",
    sign_error: "User denied message signature.",
    user_rejected: "User rejected the request",
    auth_error: "Unauthorized user",
    insufficient_funds: "Insufficient funds",
    wallet_disconnected: "Wallet Disconnected",
    connect_wallet: "Connect Wallet",
    network: "Incorrect network selected. Please switch to the correct network and try again.",
    insufficient_funds_for_gas:
        "The total cost of executing this transaction exceeds the balance of the account.",
    gas_error:
        "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account.",
};

export const tabs = ["active", "inactive"];

export const sortOptions = {
    // performance: "",
    commission: "commission",
    stake: "total_staked",
};

export const dollarFieldsMapper = {
    price: true,
    market_cap: true,
    total_staked: true,
    total_rewards_distributed: true,
};
export const toolTipMapper = {
    price: false,
    market_cap: false,
    total_rewards_distributed: true,
    total_staked: true,
    total_dPoS_validators: true,
    block_height: true,
    last_checkpoint: true,
    checkpoint_interval: true,
    performance_benchmark: true,
    validator_stake: true,
};

export const status = {
    STAKING: "STAKING",
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    CANCELLED: "CENCELLED",
    UNSTAKING: "UNSTAKING",
    CLAIM_STAKE: "CLAIM STAKE",
    CLAIM_REWARD: "CLAIM REWARD",
};

export const message = {
    validator: "This reward combines your Validator Commission and Delegator Rewards.",
    delegator: "This reward combines your Validator Commission and Delegator Rewards."
}
export const getPricingApiUrl = {
    develop: "https://mrawakxvyzsfqtkm.bimtvi.com/vanary-price",
    staging: "https://mRAWakXvyzSfQtkM.bimtvist.com/vanary-price",
    production: "https://mrawakxvyzsfqtkm.vanarchain.com/vanary-price",
    pre_prod: "https://mrawakxvyzsfqtkm.vanarchain.com/vanary-price",
};

export const vanarExplorerUrl = process.env.REACT_APP_VANAR_EXPLORER_URL;
export const preStakingUrl = process.env.REACT_APP_VANAR_PRESTAKING_URL;
export const vanarChainId = process.env.REACT_APP_VANAR_CHAIN_ID;
export const vanarRpcUrl = process.env.REACT_APP_VANAR_RPC_URL;
export const termsOfUseUrl = process.env.REACT_APP_TERMS_OF_USE_URL;
export const vanarChainName = process.env.REACT_APP_VANAR_CHAIN_NAME;
export const envChains = JSON.parse(process.env.REACT_APP_CHAIN);
export const walletConnectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID;
export const cloudFunctionBaseUrl =
    process.env.REACT_APP_CLOUD_FUNCTION_BASE_URL;

export const walletIcons = {
    metaMaskSDK: (customClass) => <MetaMask className={customClass} />,
    walletConnect: (customClass) => <WalletConnect className={customClass} />,
    coinbaseWalletSDK: (customClass) => <Coinbase2 className={customClass} />,
};

export const views = {
    grid: generalIcons.cardIcon,
    list: generalIcons.tabularIcon,
};
export const myAccountTabs = {
    myAccount: "My Account",
    transactionHistory: "Transaction History",
};
export const detailPageTabs = {
    delegators: "Delegators",
};

export const paginationArrows = {
    previousArrow: (opacity) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <g opacity={opacity}>
                <path
                    d="M14 7L10 12L14 17"
                    stroke="#FFF5F5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    nextArrow: (opacity) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <g opacity={opacity}>
                <path
                    d="M10 7L14 12L10 17"
                    stroke="#FFF5F5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
};

export const transactionHistoryFilters = {
    allTransactions: "All Transactions",
    unStake: "Unstake",
    stake: "Stake",
    claimStake: "Claim Stake",
    claimReward: "Claim Reward",
};

export const validatorDetailCardSections = {
    overview: {
        total_staked: "Total Staked",
        commission: "Validator Commission",
        commission_earned: "Commission Earned",
    },
    performanceMatrics: {
        apy: "APY",
        // block_production: "Block Production",
    },
    delegatorsDetail: {
        total_delegators: "No. of Delegators",
        total_rewards: "Rewards",
    },
};
export const delegatorDetailCardSections = {
    overview: {
        total_staked: "Total Amount",
        commission_earned: "Commission Earned",
    },
    delegatorsDetail: {
        node_name: "Node Name",
        amount: "Amount Staked",
        rewards_earned: "Total Claimable Rewards",
        apy: "APY",
    },
};

export const userBulletinOverview = {
    total_staked: "Total Stake",
    validator_stake: "Validator Stake",
    total_rewards_distributed: "Total Rewwards Earned",
    health_status: "Health Status",
    // performance_index: "Performance Index",
};

export const GENERAL_ICONS = {
    footer_logo: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="276"
            height="48"
            viewBox="0 0 276 48"
            fill="none"
        >
            <path
                d="M34.4309 48L41.3157 35.9946L20.6614 0H6.88475L0 11.9982H13.7838L34.4309 48ZM48.2076 23.9964L55.0995 11.9982L48.2076 0H34.4381L27.5533 11.9982H41.3228L48.2076 23.9964Z"
                fill="#03D9AF"
            />
            <path
                d="M41.3228 11.9982L48.2076 0H34.4381L27.5533 11.9982H41.3228Z"
                fill="#03D9AF"
            />
            <path
                d="M13.7838 11.9982L20.6614 0H6.88475L0 11.9982H13.7838Z"
                fill="#03D9AF"
            />
            <path
                d="M92.8151 41.6777C91.0381 41.6777 89.7157 41.0194 88.8066 39.7029L72.7313 16.4983L79.4672 12.9189L92.5258 31.5154C92.6085 31.6389 92.6911 31.7211 92.8151 31.7211C92.8977 31.7211 93.0217 31.68 93.1044 31.5154L106.122 12.9189L112.858 16.4983L96.7823 39.7029C95.8731 41.0194 94.5507 41.6777 92.8151 41.6777Z"
                fill="#F7F7F7"
            />
            <path
                d="M144.599 41.76L140.921 36.6583H119.969L116.291 41.76L109.555 38.1806L126.457 14.976C127.408 13.6594 128.73 13.0011 130.466 13.0011C132.119 13.0011 133.441 13.6594 134.433 14.976L151.335 38.1806L144.599 41.76ZM124.556 30.3634H136.375L130.755 22.5874C130.631 22.464 130.548 22.3817 130.466 22.3817C130.383 22.3817 130.259 22.464 130.176 22.5874L124.556 30.3634Z"
                fill="#F7F7F7"
            />
            <path
                d="M186.408 41.5954C184.961 41.5954 183.639 41.1017 182.44 40.0731L163.72 24.2743C163.555 24.192 163.431 24.1509 163.348 24.192C163.266 24.2743 163.224 24.3566 163.224 24.5211V41.1429H155.497V18.8023C155.497 16.7451 155.869 15.3051 156.613 14.4823C157.356 13.6594 158.39 13.248 159.671 13.248C161.076 13.248 162.398 13.7829 163.638 14.7703L182.358 30.528C182.482 30.6514 182.606 30.6926 182.688 30.6103C182.771 30.5691 182.854 30.4457 182.854 30.2811V13.6183H190.581V36.0411C190.581 38.1394 190.168 39.5794 189.424 40.4023C188.68 41.2251 187.647 41.5954 186.408 41.5954Z"
                fill="#F7F7F7"
            />
            <path
                d="M230.596 41.76L226.918 36.6583H205.966L202.289 41.76L195.553 38.1806L212.454 14.976C213.405 13.6594 214.727 13.0011 216.463 13.0011C218.116 13.0011 219.438 13.6594 220.43 14.976L237.332 38.1806L230.596 41.76ZM210.553 30.3634H222.372L216.752 22.5874C216.628 22.464 216.546 22.3817 216.463 22.3817C216.38 22.3817 216.256 22.464 216.174 22.5874L210.553 30.3634Z"
                fill="#F7F7F7"
            />
            <path
                d="M276 38.2629L269.388 42.3771L260.958 32.9966H249.346V41.184H241.494V19.8309C241.494 17.856 241.99 16.2926 243.064 15.2229C244.139 14.1531 245.668 13.6183 247.693 13.6183H264.677C268.644 13.6183 271.496 14.4 273.231 15.9634C274.967 17.5269 275.876 19.9954 275.876 23.2869C275.876 28.1417 273.892 31.1451 269.967 32.3794L276 38.2629ZM249.346 21.6411V25.9611H265.173C266.165 25.9611 266.909 25.8377 267.363 25.5497C267.776 25.2617 268.024 24.6034 268.024 23.616C268.024 22.6286 267.776 22.0114 267.322 21.6823C266.867 21.3943 266.165 21.2297 265.173 21.2297H249.759C249.47 21.2297 249.346 21.3943 249.346 21.6411Z"
                fill="#F7F7F7"
            />
        </svg>
    ),
    metamask_icon: (
        <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.9406 0.0687023L11.1914 5.65262L12.6247 2.35808L18.9406 0.0687023Z"
                fill="#E2761B"
            ></path>
            <path
                d="M1.05157 0.0687023L8.7385 5.70546L7.37532 2.35808L1.05157 0.0687023Z"
                fill="#E4761B"
            ></path>
            <path
                d="M16.1523 13.0123L14.0886 16.0803L18.5045 17.2588L19.774 13.0803L16.1523 13.0123Z"
                fill="#E4761B"
            ></path>
            <path
                d="M0.233816 13.0803L1.49551 17.2588L5.91144 16.0803L3.84767 13.0123L0.233816 13.0803Z"
                fill="#E4761B"
            ></path>
            <path
                d="M5.66224 7.8287L4.4315 9.63488L8.81608 9.82383L8.66053 5.2523L5.66224 7.8287Z"
                fill="#E4761B"
            ></path>
            <path
                d="M14.3299 7.8287L11.2928 5.19946L11.1914 9.82383L15.5685 9.63488L14.3299 7.8287Z"
                fill="#E4761B"
            ></path>
            <path
                d="M5.91144 16.0803L8.54376 14.8333L6.26958 13.1104L5.91144 16.0803Z"
                fill="#E4761B"
            ></path>
            <path
                d="M11.4484 14.8333L14.0886 16.0803L13.7226 13.1104L11.4484 14.8333Z"
                fill="#E4761B"
            ></path>
            <path
                d="M14.0886 16.0803L11.4484 14.8333L11.6588 16.5034L11.6353 17.2059L14.0886 16.0803Z"
                fill="#D7C1B3"
            ></path>
            <path
                d="M5.91144 16.0803L8.36469 17.2059L8.34902 16.5034L8.54376 14.8333L5.91144 16.0803Z"
                fill="#D7C1B3"
            ></path>
            <path
                d="M8.40349 12.0075L6.20727 11.3802L7.75697 10.6925L8.40349 12.0075Z"
                fill="#233447"
            ></path>
            <path
                d="M11.5887 12.0075L12.2352 10.6925L13.7927 11.3802L11.5887 12.0075Z"
                fill="#233447"
            ></path>
            <path
                d="M5.91144 16.0803L6.28525 13.0123L3.84767 13.0803L5.91144 16.0803Z"
                fill="#CD6116"
            ></path>
            <path
                d="M13.7148 13.0123L14.0886 16.0803L16.1523 13.0803L13.7148 13.0123Z"
                fill="#CD6116"
            ></path>
            <path
                d="M15.5685 9.63488L11.1914 9.82383L11.5965 12.0075L12.243 10.6925L13.8006 11.3802L15.5685 9.63488Z"
                fill="#CD6116"
            ></path>
            <path
                d="M6.20727 11.3802L7.7648 10.6925L8.40349 12.0075L8.81608 9.82383L4.4315 9.63488L6.20727 11.3802Z"
                fill="#CD6116"
            ></path>
            <path
                d="M4.4315 9.63488L6.26958 13.1104L6.20727 11.3802L4.4315 9.63488Z"
                fill="#E4751F"
            ></path>
            <path
                d="M13.8006 11.3802L13.7226 13.1104L15.5685 9.63488L13.8006 11.3802Z"
                fill="#E4751F"
            ></path>
            <path
                d="M8.81608 9.82383L8.40349 12.0075L8.91757 14.5839L9.03433 11.1913L8.81608 9.82383Z"
                fill="#E4751F"
            ></path>
            <path
                d="M11.1914 9.82383L10.9813 11.1837L11.0746 14.5839L11.5965 12.0075L11.1914 9.82383Z"
                fill="#E4751F"
            ></path>
            <path
                d="M11.5965 12.0075L11.0746 14.5839L11.4484 14.8333L13.7226 13.1104L13.8006 11.3802L11.5965 12.0075Z"
                fill="#F6851B"
            ></path>
            <path
                d="M6.20727 11.3802L6.26958 13.1104L8.54376 14.8333L8.91757 14.5839L8.40349 12.0075L6.20727 11.3802Z"
                fill="#F6851B"
            ></path>
            <path
                d="M11.6353 17.2059L11.6588 16.5034L11.4641 16.3369H8.52809L8.34902 16.5034L8.36469 17.2059L5.91144 16.0803L6.76798 16.76L8.50458 17.9313H11.4876L13.232 16.76L14.0886 16.0803L11.6353 17.2059Z"
                fill="#C0AD9E"
            ></path>
            <path
                d="M11.4484 14.8333L11.0746 14.5839H8.91757L8.54376 14.8333L8.34902 16.5034L8.52809 16.3369H11.4641L11.6588 16.5034L11.4484 14.8333Z"
                fill="#161616"
            ></path>
            <path
                d="M19.2678 6.0153L19.9296 2.93251L18.9406 0.0687023L11.4484 5.46367L14.3299 7.8287L18.403 8.98479L19.3066 7.9648L18.9171 7.69298L19.5401 7.14136L19.0574 6.77868L19.6804 6.31753L19.2678 6.0153Z"
                fill="#763D16"
            ></path>
            <path
                d="M0.0704225 2.93251L0.732225 6.0153L0.31179 6.31753L0.934801 6.77868L0.459902 7.14136L1.08291 7.69298L0.693433 7.9648L1.58916 8.98479L5.66224 7.8287L8.54376 5.46367L1.05157 0.0687023L0.0704225 2.93251Z"
                fill="#763D16"
            ></path>
            <path
                d="M18.403 8.98479L14.3299 7.8287L15.5685 9.63488L13.7226 13.1104L16.1523 13.0803H19.774L18.403 8.98479Z"
                fill="#F6851B"
            ></path>
            <path
                d="M5.66224 7.8287L1.58916 8.98479L0.233816 13.0803H3.84767L6.26958 13.1104L4.4315 9.63488L5.66224 7.8287Z"
                fill="#F6851B"
            ></path>
            <path
                d="M11.1914 9.82383L11.4484 5.46367L12.6325 2.35808H7.37532L8.54376 5.46367L8.81608 9.82383L8.90973 11.1989L8.91757 14.5839H11.0746L11.0903 11.1989L11.1914 9.82383Z"
                fill="#F6851B"
            ></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.02116 0.0067338C1.03837 -0.001302 1.05818 -0.00218313 1.07607 0.004292L7.38797 2.28937H12.612L18.9161 0.00430167C18.9339 -0.00217223 18.9537 -0.00130974 18.9709 0.00669227C18.9881 0.0146943 19.0013 0.0291529 19.0073 0.0467678L19.9963 2.91058C20.0003 2.92218 20.0011 2.93461 19.9985 2.94659L19.3459 5.9866L19.7227 6.26259C19.7403 6.27553 19.7507 6.29581 19.7508 6.31736C19.7509 6.33891 19.7405 6.35924 19.7229 6.37226L19.1733 6.77908L19.5831 7.08692C19.5996 7.09934 19.6096 7.11826 19.6105 7.13858C19.6113 7.15891 19.6029 7.17856 19.5874 7.19223L19.029 7.68664L19.3475 7.90892C19.3636 7.92016 19.3742 7.93749 19.3765 7.95667C19.3788 7.97585 19.3728 7.99511 19.3598 8.00972L18.4823 9.00035L19.841 13.059C19.8454 13.0723 19.8456 13.0865 19.8415 13.0999L18.572 17.2783C18.5611 17.3141 18.5229 17.3349 18.4859 17.325L14.1049 16.1558L13.2765 16.8133C13.275 16.8145 13.2735 16.8156 13.2719 16.8166L11.5275 17.9879C11.5158 17.9958 11.5018 18 11.4876 18H8.50458C8.49027 18 8.4763 17.9957 8.46453 17.9878L6.72794 16.8165C6.72643 16.8155 6.72497 16.8144 6.72355 16.8133L5.8951 16.1558L1.51409 17.325C1.47709 17.3349 1.4388 17.3141 1.42796 17.2782L0.166263 13.0998C0.162262 13.0865 0.162449 13.0724 0.166799 13.0592L1.51003 9.00029L0.639953 8.0095C0.627106 7.99487 0.621145 7.97565 0.623523 7.95653C0.625901 7.9374 0.6364 7.92013 0.65246 7.90892L0.970964 7.68664L0.412574 7.19223C0.397204 7.17862 0.388771 7.15909 0.389526 7.13886C0.390282 7.11862 0.400149 7.09974 0.416493 7.08726L0.819441 6.77953L0.269224 6.37226C0.251537 6.35917 0.241214 6.33871 0.241369 6.31705C0.241525 6.29539 0.252141 6.27507 0.270015 6.26222L0.654022 5.98618L0.00149543 2.94659C-0.00106503 2.93467 -0.000327672 2.92229 0.00363189 2.91073L0.984776 0.046924C0.990823 0.0292724 1.00395 0.0147696 1.02116 0.0067338ZM1.6447 9.04058L0.331164 13.0098L3.84631 12.9436C3.87052 12.9432 3.89326 12.9549 3.90655 12.9746L3.9299 13.0093L6.10478 12.9486L4.36892 9.66638C4.3572 9.64423 4.3587 9.61761 4.37285 9.59685L5.49695 7.94717L1.6447 9.04058ZM5.7153 7.87493L4.55917 9.57162L8.74103 9.75182L8.48198 5.60416L5.7153 7.87493ZM8.73216 9.88898L4.60845 9.71128L6.22273 11.2979L7.72781 10.63C7.73852 10.6252 7.74983 10.6233 7.76084 10.6239C7.78862 10.6224 7.81582 10.6371 7.82844 10.6631L8.37376 11.7859L8.73216 9.88898ZM8.27168 11.8983L7.72465 10.7857L6.40943 11.3664L8.27168 11.8983ZM6.28108 11.4729L6.33475 12.9634C6.3356 12.9642 6.33642 12.9651 6.33723 12.9659C6.35104 12.9807 6.3576 13.0006 6.35518 13.0204L6.34761 13.0825L8.5464 14.7483L8.8396 14.5527L8.34255 12.0617L6.28108 11.4729ZM8.47516 12.0072L8.84548 13.8631L8.83931 11.2013L8.78318 10.377L8.47516 12.0072ZM8.93934 14.6526L8.61009 14.8723L8.44093 16.323L8.4795 16.2871C8.4926 16.275 8.51 16.2682 8.52809 16.2682H11.4641C11.4812 16.2682 11.4976 16.2742 11.5105 16.2852L11.5664 16.333L11.3824 14.8725L11.0528 14.6526H8.93934ZM11.1527 14.5528L11.4458 14.7483L13.6517 13.0771L13.6448 13.0204C13.6427 13.0028 13.6476 12.9852 13.6584 12.9711L13.7259 11.4731L11.6573 12.0618L11.1527 14.5528ZM13.8697 11.4097L13.807 12.8022L15.2926 10.005L13.8697 11.4097ZM15.4404 9.57164L14.2769 7.875L11.5106 5.60453L11.2661 9.75183L15.4404 9.57164ZM11.3454 6.01432L11.3692 5.60985L11.354 5.62081L11.3454 6.01432ZM11.3578 5.44724L11.3877 5.4257L11.4027 5.38643L11.3889 5.37445L11.3579 5.44571L11.3578 5.44724ZM11.4469 5.24101L11.4554 5.24831L11.5378 5.03226L11.4469 5.24101ZM12.6885 2.40822L11.5969 5.27138L18.4969 0.302838L12.6885 2.40822ZM14.3648 7.76705L18.3793 8.90651L19.2028 7.97686L18.8761 7.74886C18.8588 7.73677 18.848 7.7177 18.8468 7.69696C18.8455 7.67623 18.854 7.65606 18.8698 7.64211L19.4304 7.14568L19.0144 6.83311C18.997 6.82005 18.9869 6.79983 18.9869 6.77843C18.987 6.75703 18.9973 6.73688 19.0148 6.72394L19.5635 6.31782L19.2255 6.07024C19.2036 6.05422 19.1932 6.02732 19.1989 6.00121L19.8567 2.93673L18.9047 0.179972L11.6442 5.41175L14.3648 7.76705ZM18.3476 9.04062L14.4961 7.94741L15.627 9.59668C15.6413 9.6175 15.6428 9.64425 15.631 9.66649L13.8879 12.9484L16.0701 13.0093L16.0935 12.9746C16.1067 12.9549 16.1295 12.9432 16.1537 12.9436L19.6763 13.0098L18.3476 9.04062ZM13.6675 13.2391L11.5812 14.8197L14.0033 15.9636L13.6675 13.2391ZM13.925 16.0794L11.5341 14.9501L11.7287 16.495C11.7289 16.4964 11.729 16.4979 11.7291 16.4993C11.7292 16.5014 11.7293 16.5035 11.7292 16.5056L11.7094 17.096L13.925 16.0794ZM13.5972 16.3817L11.6653 17.2681C11.6431 17.2783 11.6171 17.2765 11.5966 17.2633C11.5761 17.2502 11.5641 17.2276 11.5649 17.2037L11.5873 16.5336L11.4376 16.4056H8.55628L8.4201 16.5322L8.4351 17.2044C8.43563 17.2282 8.42352 17.2506 8.40308 17.2635C8.38264 17.2765 8.35678 17.2782 8.33472 17.2681L6.40283 16.3817L6.81029 16.705L8.52655 17.8626H11.4657L13.1898 16.705L13.5972 16.3817ZM6.07475 16.0793L8.29182 17.0966L8.27862 16.5049C8.27855 16.5018 8.27869 16.4987 8.27905 16.4956L8.45932 14.9497L6.07475 16.0793ZM8.41109 14.8198L5.99658 15.9636L6.32821 13.2418L8.41109 14.8198ZM6.18817 12.8066L4.70393 10.0002L6.13786 11.4095L6.18817 12.8066ZM6.1905 13.1781L4.02538 13.1513L5.86412 15.8847L6.1905 13.1781ZM0.327975 13.1491L1.54355 17.1747L5.79839 16.0392L3.81012 13.1491H0.327975ZM14.2016 16.0392L18.4566 17.1748L19.6797 13.1491H16.1899L14.2016 16.0392ZM15.9746 13.1513L13.8059 13.1781L14.1357 15.885L15.9746 13.1513ZM12.5183 2.42678L11.3357 5.14495C11.3155 5.1298 11.2883 5.12644 11.2647 5.1365C11.2395 5.14721 11.223 5.17121 11.2224 5.19799L11.2176 5.41635L11.1265 5.62577C11.1141 5.65429 11.1228 5.68737 11.1477 5.70655C11.166 5.7206 11.1896 5.72465 11.211 5.7186L11.1211 9.81795L10.9117 11.1735C10.9111 11.1774 10.9108 11.1815 10.9109 11.1855L11.0023 14.5152H8.99039L9.10472 11.1936C9.10487 11.1893 9.1046 11.185 9.10392 11.1807L8.88633 9.81738L8.74872 5.77344C8.76027 5.77179 8.77149 5.76733 8.78124 5.76006C8.80632 5.74138 8.8156 5.7087 8.80395 5.68009L8.74022 5.52361L8.73091 5.25002C8.73001 5.22345 8.71347 5.19977 8.68845 5.18923C8.66344 5.17869 8.63443 5.18317 8.61398 5.20074L8.6101 5.20408L7.47908 2.42678H12.5183ZM7.32039 2.41147L1.49472 0.302415L8.3968 5.27246L7.32039 2.41147ZM1.08738 0.180908L0.14326 2.93664L0.801152 6.00121C0.806802 6.02754 0.796192 6.05465 0.774 6.07061L0.429386 6.31834L0.977367 6.72394C0.994767 6.73682 1.00506 6.75685 1.00522 6.77816C1.00539 6.79946 0.995409 6.81964 0.97821 6.83277L0.569069 7.14524L1.13024 7.64211C1.14601 7.65606 1.15445 7.67623 1.15322 7.69696C1.15198 7.7177 1.1412 7.73677 1.12389 7.74886L0.796921 7.97705L1.61309 8.90645L5.62748 7.76701L8.30043 5.47017L1.08738 0.180908ZM11.1483 13.8655L11.5209 12.0263C11.5173 12.0138 11.5173 12.0003 11.5213 11.9876L11.2216 10.3726L11.1607 11.2015L11.1483 13.8655ZM11.275 9.88898L11.6249 11.7749L12.1717 10.6628C12.1844 10.637 12.2115 10.6224 12.2392 10.6239C12.2501 10.6233 12.2614 10.6252 12.2721 10.6299L13.7849 11.2979L15.3921 9.71126L11.275 9.88898ZM13.5903 11.3663L12.2753 10.7857L11.7295 11.8959L13.5903 11.3663Z"
                fill="#F6851B"
            ></path>
        </svg>
    ),
};

export const SOCIAL_LINKS = [
    {
        name: "discord",
        id:"discord",
        svg: (
            <svg
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M17.6827 1.47711C16.3861 0.881894 15.0177 0.457449 13.6118 0.21441C13.599 0.212046 13.5859 0.21377 13.5741 0.219335C13.5624 0.2249 13.5527 0.234024 13.5464 0.24541C13.3706 0.558011 13.1758 0.966012 13.0395 1.28661C11.5022 1.05641 9.97292 1.05641 8.46721 1.28661C8.33081 0.958812 8.12901 0.558011 7.95241 0.24541C7.94587 0.234258 7.93613 0.225334 7.92444 0.219804C7.91276 0.214274 7.89968 0.212394 7.88691 0.21441C6.48092 0.456958 5.11246 0.881422 3.816 1.47711C3.8049 1.48182 3.79554 1.48986 3.7892 1.50011C1.19639 5.37372 0.486191 9.15213 0.834592 12.8837C0.835562 12.8929 0.838364 12.9017 0.842831 12.9098C0.847298 12.9178 0.853339 12.9249 0.860592 12.9305C2.5712 14.1868 4.2283 14.9495 5.85461 15.4551C5.86726 15.4588 5.88076 15.4586 5.8933 15.4545C5.90585 15.4504 5.91684 15.4426 5.92481 15.432C6.30951 14.9066 6.65241 14.3527 6.94651 13.7702C6.95056 13.7623 6.95287 13.7535 6.95329 13.7446C6.95372 13.7356 6.95224 13.7267 6.94896 13.7184C6.94568 13.7101 6.94067 13.7025 6.93427 13.6963C6.92787 13.69 6.92021 13.6852 6.91181 13.6821C6.36781 13.4757 5.84991 13.2242 5.3517 12.9385C5.34263 12.9332 5.33501 12.9257 5.32952 12.9167C5.32402 12.9077 5.32082 12.8975 5.3202 12.887C5.31958 12.8765 5.32155 12.866 5.32595 12.8564C5.33034 12.8469 5.33702 12.8385 5.3454 12.8321C5.4505 12.7536 5.5538 12.6726 5.6552 12.5893C5.66408 12.582 5.67484 12.5773 5.68625 12.5757C5.69767 12.5742 5.70929 12.5758 5.71981 12.5805C8.99301 14.0749 12.5365 14.0749 15.771 12.5805C15.7816 12.5755 15.7933 12.5736 15.8049 12.5751C15.8165 12.5765 15.8275 12.5811 15.8365 12.5885C15.938 12.6723 16.0416 12.7535 16.1471 12.8321C16.1556 12.8385 16.1623 12.8468 16.1667 12.8563C16.1712 12.8658 16.1733 12.8763 16.1727 12.8868C16.1722 12.8973 16.1691 12.9075 16.1636 12.9166C16.1582 12.9256 16.1507 12.9331 16.1416 12.9385C15.6431 13.2296 15.121 13.4781 14.5807 13.6813C14.5723 13.6846 14.5647 13.6895 14.5584 13.6958C14.552 13.7022 14.5471 13.7098 14.5439 13.7182C14.5407 13.7266 14.5393 13.7356 14.5398 13.7445C14.5403 13.7535 14.5427 13.7623 14.5468 13.7702C14.846 14.3481 15.1872 14.9033 15.5676 15.4313C15.5754 15.4421 15.5863 15.4502 15.5989 15.4544C15.6115 15.4587 15.6251 15.4589 15.6378 15.4551C17.272 14.9495 18.9291 14.1868 20.6398 12.9305C20.6472 12.9251 20.6533 12.9183 20.6578 12.9103C20.6622 12.9024 20.665 12.8936 20.6658 12.8845C21.0828 8.57043 19.9673 4.82292 17.7087 1.50091C17.7032 1.49012 17.694 1.48167 17.6827 1.47711ZM7.43531 10.6116C6.44981 10.6116 5.63781 9.70693 5.63781 8.59583C5.63781 7.48473 6.43411 6.58003 7.43531 6.58003C8.44431 6.58003 9.24841 7.49273 9.23261 8.59583C9.23261 9.70693 8.43641 10.6116 7.43531 10.6116ZM14.0809 10.6116C13.0954 10.6116 12.2835 9.70693 12.2835 8.59583C12.2835 7.48473 13.0797 6.58003 14.0809 6.58003C15.0899 6.58003 15.894 7.49273 15.8783 8.59583C15.8783 9.70693 15.0899 10.6116 14.0809 10.6116Z"
                    fill="currentColor"
                ></path>
            </svg>
        ),
        // url: "https://discord.gg/924SFcdGKf",
        url: "https://discord.com/invite/fBwPGQUwBm"
    },
    {
        name: "twitter",
        id:"twitter",
        svg: (
            <svg
                width="50%"
                height="50%"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.49233 9.57605L0 0H5.93445L10.5594 5.91866L15.5004 0.0266487H18.7688L12.1397 7.94098L20 18H14.0833L9.07538 11.5993L3.72896 17.9823H0.44287L7.49233 9.57605ZM14.9457 16.2257L3.63881 1.77427H5.07138L16.364 16.2257H14.9457Z"
                    fill="currentColor"
                ></path>
            </svg>
        ),
        url: "https://twitter.com/vanarchain",
    },
    {
        name: "telegram",
        id:"telegram",
        svg: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.9593 16.3852L16.9599 16.3836L16.9775 16.3412L20 1.59794V1.55005C20 1.18271 19.8597 0.862027 19.5544 0.669671C19.2872 0.501301 18.98 0.48931 18.7647 0.505128C18.5369 0.521856 18.322 0.576869 18.1733 0.622662C18.0968 0.646221 18.0328 0.668921 17.987 0.68609C17.964 0.694707 17.9454 0.702019 17.9319 0.707467L17.9186 0.712886L1.06641 7.10877L1.06177 7.11038C1.05267 7.11359 1.04063 7.11793 1.0261 7.12341C0.997114 7.13432 0.957664 7.14994 0.91132 7.17026C0.820324 7.21016 0.694601 7.27173 0.567098 7.35621C0.350544 7.49968 -0.0618076 7.83935 0.00782129 8.37784C0.0654948 8.82388 0.383293 9.10716 0.597544 9.25383C0.712395 9.33245 0.822271 9.38914 0.902731 9.4262C0.943499 9.44498 0.978129 9.45936 1.00392 9.46952C1.01685 9.47462 1.02766 9.47869 1.03602 9.48176L1.04673 9.48563L1.05358 9.48809L4.00197 10.4484C3.99202 10.6274 4.01037 10.8099 4.05943 10.9899L5.53631 16.4101C5.71142 17.0528 6.31236 17.5005 6.99933 17.5C7.61509 17.4996 8.16121 17.1392 8.39322 16.6015L10.699 14.2162L14.6591 17.1535L14.7154 17.1773C15.0752 17.3292 15.4113 17.3773 15.7187 17.3367C16.0256 17.2962 16.2695 17.1716 16.4526 17.0298C16.6329 16.8903 16.7565 16.7328 16.8342 16.6142C16.8736 16.554 16.9031 16.5011 16.9235 16.4612C16.9337 16.4412 16.9418 16.4243 16.9479 16.4111L16.9555 16.3941L16.9582 16.3878L16.9593 16.3852ZM5.52131 10.617C5.48774 10.4939 5.54043 10.3638 5.65159 10.2955L15.6521 4.15124C15.6521 4.15124 16.2403 3.80575 16.2193 4.15124C16.2193 4.15124 16.3243 4.21225 16.0091 4.49673C15.7101 4.76691 8.88145 11.1454 8.19049 11.7908C8.1506 11.8281 8.1268 11.8708 8.11274 11.9227L6.99819 16.0373L5.52131 10.617Z"
                    fill="currentColor"
                ></path>
            </svg>
        ),
        url: "https://t.me/vanarofficial",
    },
    // {
    //     name: "medium",
    //     svg: (
    //         <svg
    //             width="24"
    //             height="24"
    //             viewBox="0 0 24 24"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //         >
    //             <g clipPath="url(#clip0_7883_2967)">
    //                 <g>
    //                     <path
    //                         d="M13.2868 11.9879C13.2868 15.4006 10.539 18.1672 7.14962 18.1672C3.76022 18.1672 1.01221 15.4006 1.01221 11.9879C1.01221 8.57513 3.76001 5.80835 7.14962 5.80835C10.5392 5.80835 13.2868 8.57513 13.2868 11.9879Z"
    //                         fill="currentColor"
    //                     ></path>
    //                 </g>
    //                 <g>
    //                     <path
    //                         d="M20.0197 11.988C20.0197 15.2003 18.6458 17.8055 16.951 17.8055C15.2562 17.8055 13.8823 15.2003 13.8823 11.988C13.8823 8.77559 15.256 6.17041 16.9508 6.17041C18.6456 6.17041 20.0195 8.77475 20.0195 11.988"
    //                         fill="currentColor"
    //                     ></path>
    //                 </g>
    //                 <g>
    //                     <path
    //                         d="M22.7736 11.988C22.7736 14.8655 22.2904 17.1996 21.6943 17.1996C21.0982 17.1996 20.6152 14.8661 20.6152 11.988C20.6152 9.10985 21.0984 6.77637 21.6943 6.77637C22.2902 6.77637 22.7736 9.10964 22.7736 11.988Z"
    //                         fill="currentColor"
    //                     ></path>
    //                 </g>
    //             </g>
    //             <defs>
    //                 <clipPath>
    //                     <rect
    //                         width="24"
    //                         height="24"
    //                         fill="white"
    //                     ></rect>
    //                 </clipPath>
    //             </defs>
    //         </svg>
    //     ),
    //     url: "https://medium.com/vanarchain",
    // },
];

// Redirection URLs
export const redirections = {
    PARTNERS: process.env.REACT_APP_VANAR_PARTNERS,
    VALIDATORS: process.env.REACT_APP_VANAR_VALIDATORS,
    DEVELOPERS: process.env.REACT_APP_VANAR_DEVELOPERS,
    ACADEMY: process.env.REACT_APP_VANAR_ACADEMY,
    VANRY: process.env.REACT_APP_VANAR_VANRY,
    NEWS: process.env.REACT_APP_VANAR_NEWS,
    BLOG: process.env.REACT_APP_VANAR_BLOG,
    BRANDGUIDELINES: process.env.REACT_APP_VANAR_BRANDGUIDELINES,
    EXPLORER: process.env.REACT_APP_VANAR_EXPLORER,
    DOCS: process.env.REACT_APP_VANAR_DOCS,
    ECO: process.env.REACT_APP_VANAR_ECO,
    GAMING: process.env.REACT_APP_VANAR_GAMING,
    AI: process.env.REACT_APP_VANAR_AI,
};
